// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../img/footer-bg.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
* Template Name: UpConstruction
* Template URL: https://bootstrapmade.com/upconstruction-bootstrap-construction-website-template/
* Updated: Aug 07 2024 with Bootstrap v5.3.3
* Author: BootstrapMade.com
* License: https://bootstrapmade.com/license/
*/

/*--------------------------------------------------------------
# Font & Color Variables
# Help: https://bootstrapmade.com/color-system/
--------------------------------------------------------------*/
/* Fonts */
.KeysHome {
  --default-font:
    "Open Sans", system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans",
    "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol",
    "Noto Color Emoji";
  --heading-font: "Roboto", sans-serif;
  --nav-font: "Poppins", sans-serif;
}

/* Global Colors - The following color variables are used throughout the website. Updating them here will change the color scheme of the entire website */
.KeysHome {
  --background-color: #ffffff;
  /* Background color for the entire website, including individual sections */
  --default-color: #364d59;
  /* Default color used for the majority of the text content across the entire website */
  --heading-color: #52565e;
  /* Color for headings, subheadings and title throughout the website */
  --accent-color: #feb900;
  /* Accent color that represents your brand on the website. It's used for buttons, links, and other elements that need to stand out */
  --surface-color: #ffffff;
  /* The surface color is used as a background of boxed elements within sections, such as cards, icon boxes, or other elements that require a visual separation from the global background. */
  --contrast-color: #ffffff;
  /* Contrast color for text, ensuring readability against backgrounds of accent, heading, or default colors. */
}

/* Nav Menu Colors - The following color variables are used specifically for the navigation menu. They are separate from the global colors to allow for more customization options */
.KeysHome {
  --nav-color: rgba(255, 255, 255, 0.55);
  /* The default color of the main navmenu links */
  --nav-hover-color: #ffffff;
  /* Applied to main navmenu links when they are hovered over or active */
  --nav-mobile-background-color: #ffffff;
  /* Used as the background color for mobile navigation menu */
  --nav-dropdown-background-color: #ffffff;
  /* Used as the background color for dropdown items that appear when hovering over primary navigation items */
  --nav-dropdown-color: #212529;
  /* Used for navigation links of the dropdown items in the navigation menu. */
  --nav-dropdown-hover-color: #feb900;
  /* Similar to --nav-hover-color, this color is applied to dropdown navigation links when they are hovered over. */
}

/* Color Presets - These classes override global colors when applied to any section or element, providing reuse of the sam color scheme. */

.KeysHome .light-background {
  --background-color: #f4f7f6;
  --surface-color: #ffffff;
}

.KeysHome .dark-background {
  --background-color: #060606;
  --default-color: #ffffff;
  --heading-color: #ffffff;
  --surface-color: #252525;
  --contrast-color: #ffffff;
}

/* Smooth scroll */
.KeysHome {
  scroll-behavior: smooth;
}

/*--------------------------------------------------------------
# General Styling & Shared Classes
--------------------------------------------------------------*/
.KeysHome {
  color: var(--default-color);
  background-color: var(--background-color);
  font-family: var(--default-font);
}

.KeysHome a {
  color: var(--accent-color);
  text-decoration: none;
  transition: 0.3s;
}

.KeysHome a:hover {
  color: color-mix(in srgb, var(--accent-color), transparent 25%);
  text-decoration: none;
}

.KeysHome h1,
.KeysHome h2,
.KeysHome h3,
.KeysHome h4,
.KeysHome h5,
.KeysHome h6 {
  color: var(--heading-color);
  font-family: var(--heading-font);
}

/* PHP Email Form Messages
------------------------------*/
.KeysHome .php-email-form .error-message {
  display: none;
  background: #df1529;
  color: #ffffff;
  text-align: left;
  padding: 15px;
  margin-bottom: 24px;
  font-weight: 600;
}

.KeysHome .php-email-form .sent-message {
  display: none;
  color: #ffffff;
  background: #059652;
  text-align: center;
  padding: 15px;
  margin-bottom: 24px;
  font-weight: 600;
}

.KeysHome .php-email-form .loading {
  display: none;
  background: var(--surface-color);
  text-align: center;
  padding: 15px;
  margin-bottom: 24px;
}

.KeysHome .php-email-form .loading:before {
  content: "";
  display: inline-block;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  margin: 0 10px -6px 0;
  border: 3px solid var(--accent-color);
  border-top-color: var(--surface-color);
  animation: php-email-form-loading 1s linear infinite;
}

@keyframes php-email-form-loading {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

/*--------------------------------------------------------------
# Global Header
--------------------------------------------------------------*/
.KeysHome .header {
  --background-color: rgba(255, 255, 255, 0);
  --default-color: #ffffff;
  --heading-color: #ffffff;
  color: var(--default-color);
  background-color: var(--background-color);
  padding: 20px 0;
  transition: all 0.5s;
  z-index: 997;
}

.KeysHome .header .logo img {
  max-height: 32px;
  margin-right: 8px;
}

.KeysHome .header .logo h1 {
  font-size: 24px;
  margin: 0;
  font-weight: 700;
  color: var(--heading-color);
}

.KeysHome .header .logo span {
  font-size: 24px;
  padding-left: 1px;
  font-family: var(--heading-font);
  color: var(--color-primary);
}

.KeysHome .scrolled .header {
  box-shadow: 0px 0 18px rgba(0, 0, 0, 0.1);
}

/* Global Header on Scroll
------------------------------*/
.KeysHome .scrolled .header {
  --background-color: rgba(255, 255, 255, 0.95);
  --heading-color: #3c3c3c;
  --nav-color: #3c3c3c;
  --nav-hover-color: #3c3c3c;
}

/*--------------------------------------------------------------
# Navigation Menu
--------------------------------------------------------------*/
/* Desktop Navigation */
@media (min-width: 1200px) {
  .KeysHome .navmenu {
    padding: 0;
  }

  .KeysHome .navmenu ul {
    margin: 0;
    padding: 0;
    display: flex;
    list-style: none;
    align-items: center;
  }

  .KeysHome .navmenu li {
    position: relative;
  }

  .KeysHome .navmenu > ul > li {
    white-space: nowrap;
    padding: 15px 14px;
  }

  .KeysHome .navmenu > ul > li:last-child {
    padding-right: 0;
  }

  .KeysHome .navmenu a,
  .KeysHome .navmenu a:focus {
    color: var(--nav-color);
    font-size: 14px;
    padding: 0 2px;
    font-family: var(--nav-font);
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: space-between;
    white-space: nowrap;
    transition: 0.3s;
    position: relative;
    text-transform: uppercase;
  }

  .KeysHome .navmenu a i,
  .KeysHome .navmenu a:focus i {
    font-size: 12px;
    line-height: 0;
    margin-left: 5px;
    transition: 0.3s;
  }

  .KeysHome .navmenu > ul > li > a:before {
    content: "";
    position: absolute;
    height: 2px;
    bottom: -6px;
    left: 0;
    background-color: var(--accent-color);
    visibility: hidden;
    width: 0px;
    transition: all 0.3s ease-in-out 0s;
  }

  .KeysHome .navmenu a:hover:before,
  .KeysHome .navmenu li:hover > a:before,
  .KeysHome .navmenu .active:before {
    visibility: visible;
    width: 100%;
  }

  .KeysHome .navmenu li:hover > a,
  .KeysHome .navmenu .active,
  .KeysHome .navmenu .active:focus {
    color: var(--nav-hover-color);
  }

  .KeysHome .navmenu .dropdown ul {
    margin: 0;
    padding: 10px 0;
    background: var(--nav-dropdown-background-color);
    display: block;
    position: absolute;
    visibility: hidden;
    left: 14px;
    top: 130%;
    opacity: 0;
    transition: 0.3s;
    border-radius: 4px;
    z-index: 99;
    box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1);
  }

  .KeysHome .navmenu .dropdown ul li {
    min-width: 200px;
  }

  .KeysHome .navmenu .dropdown ul a {
    padding: 10px 20px;
    font-size: 15px;
    text-transform: none;
    font-weight: 400;
    color: var(--nav-dropdown-color);
  }

  .KeysHome .navmenu .dropdown ul a i {
    font-size: 12px;
  }

  .KeysHome .navmenu .dropdown ul a:hover,
  .KeysHome .navmenu .dropdown ul .active:hover,
  .KeysHome .navmenu .dropdown ul li:hover > a {
    color: var(--nav-dropdown-hover-color);
  }

  .KeysHome .navmenu .dropdown:hover > ul {
    opacity: 1;
    top: 100%;
    visibility: visible;
  }

  .KeysHome .navmenu .dropdown .dropdown ul {
    top: 0;
    left: -90%;
    visibility: hidden;
  }

  .KeysHome .navmenu .dropdown .dropdown:hover > ul {
    opacity: 1;
    top: 0;
    left: -100%;
    visibility: visible;
  }
}

/* Mobile Navigation */
@media (max-width: 1199px) {
  .KeysHome .mobile-nav-toggle {
    color: var(--nav-color);
    font-size: 28px;
    line-height: 0;
    margin-right: 10px;
    cursor: pointer;
    transition: color 0.3s;
  }

  .KeysHome .navmenu {
    padding: 0;
    z-index: 9997;
  }

  .KeysHome .navmenu ul {
    display: none;
    list-style: none;
    position: absolute;
    inset: 60px 20px 20px 20px;
    padding: 10px 0;
    margin: 0;
    border-radius: 6px;
    background-color: var(--nav-mobile-background-color);
    border: 1px solid color-mix(in srgb, var(--default-color), transparent 90%);
    box-shadow: none;
    overflow-y: auto;
    transition: 0.3s;
    z-index: 9998;
  }

  .KeysHome .navmenu a,
  .KeysHome .navmenu a:focus {
    color: var(--nav-dropdown-color);
    padding: 10px 20px;
    font-family: var(--nav-font);
    font-size: 17px;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: space-between;
    white-space: nowrap;
    transition: 0.3s;
  }

  .KeysHome .navmenu a i,
  .KeysHome .navmenu a:focus i {
    font-size: 12px;
    line-height: 0;
    margin-left: 5px;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: 0.3s;
    background-color: color-mix(in srgb, var(--accent-color), transparent 90%);
  }

  .KeysHome .navmenu a i:hover,
  .KeysHome .navmenu a:focus i:hover {
    background-color: var(--accent-color);
    color: var(--contrast-color);
  }

  .KeysHome .navmenu a:hover,
  .KeysHome .navmenu .active,
  .KeysHome .navmenu .active:focus {
    color: var(--nav-dropdown-hover-color);
  }

  .KeysHome .navmenu .active i,
  .KeysHome .navmenu .active:focus i {
    background-color: var(--accent-color);
    color: var(--contrast-color);
    transform: rotate(180deg);
  }

  .KeysHome .navmenu .dropdown ul {
    position: static;
    display: none;
    z-index: 99;
    padding: 10px 0;
    margin: 10px 20px;
    background-color: var(--nav-dropdown-background-color);
    transition: all 0.5s ease-in-out;
  }

  .KeysHome .navmenu .dropdown ul ul {
    background-color: rgba(33, 37, 41, 0.1);
  }

  .KeysHome .navmenu .dropdown > .dropdown-active {
    display: block;
    background-color: rgba(33, 37, 41, 0.03);
  }

  .KeysHome .mobile-nav-active {
    overflow: hidden;
  }

  .KeysHome .mobile-nav-active .mobile-nav-toggle {
    color: #fff;
    position: absolute;
    font-size: 32px;
    top: 15px;
    right: 15px;
    margin-right: 0;
    z-index: 9999;
  }

  .KeysHome .mobile-nav-active .navmenu {
    position: fixed;
    overflow: hidden;
    inset: 0;
    background: rgba(33, 37, 41, 0.8);
    transition: 0.3s;
  }

  .KeysHome .mobile-nav-active .navmenu > ul {
    display: block;
  }
}

/*--------------------------------------------------------------
# Global Footer
--------------------------------------------------------------*/
.KeysHome .footer {
  color: var(--default-color);
  background-color: var(--background-color);
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) top center no-repeat;
  background-size: cover;
  font-size: 14px;
  position: relative;
}

.KeysHome .footer .container {
  position: relative;
}

.KeysHome .footer:before {
  content: "";
  background: color-mix(in srgb, var(--background-color), transparent 20%);
  position: absolute;
  inset: 0;
}

.KeysHome .footer .footer-top {
  padding-top: 50px;
}

.KeysHome .footer .footer-about .logo {
  line-height: 1;
  margin-bottom: 25px;
}

.KeysHome .footer .footer-about .logo img {
  max-height: 40px;
  margin-right: 6px;
}

.KeysHome .footer .footer-about .logo span {
  color: var(--heading-color);
  font-family: var(--heading-font);
  font-size: 26px;
  font-weight: 700;
  letter-spacing: 1px;
}

.KeysHome .footer .footer-about p {
  font-size: 14px;
  font-family: var(--heading-font);
}

.KeysHome .footer .social-links a {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 5px;
  border: 1px solid color-mix(in srgb, var(--default-color), transparent 50%);
  font-size: 16px;
  color: color-mix(in srgb, var(--default-color), transparent 20%);
  margin-right: 10px;
  transition: 0.3s;
}

.KeysHome .footer .social-links a:hover {
  color: var(--accent-color);
  border-color: var(--accent-color);
}

.KeysHome .footer h4 {
  font-size: 16px;
  font-weight: bold;
  position: relative;
  padding-bottom: 12px;
}

.KeysHome .footer .footer-links {
  margin-bottom: 30px;
}

.KeysHome .footer .footer-links ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.KeysHome .footer .footer-links ul i {
  padding-right: 2px;
  font-size: 12px;
  line-height: 0;
}

.KeysHome .footer .footer-links ul li {
  padding: 10px 0;
  display: flex;
  align-items: center;
}

.KeysHome .footer .footer-links ul li:first-child {
  padding-top: 0;
}

.KeysHome .footer .footer-links ul a {
  color: color-mix(in srgb, var(--default-color), transparent 30%);
  display: inline-block;
  line-height: 1;
}

.KeysHome .footer .footer-links ul a:hover {
  color: var(--accent-color);
}

.KeysHome .footer .footer-contact p {
  margin-bottom: 5px;
}

.KeysHome .footer .copyright {
  padding-top: 25px;
  padding-bottom: 25px;
  border-top: 1px solid color-mix(in srgb, var(--default-color), transparent 90%);
}

.KeysHome .footer .copyright p {
  margin-bottom: 0;
}

.KeysHome .footer .credits {
  margin-top: 8px;
  font-size: 13px;
}

/*--------------------------------------------------------------
# Preloader
--------------------------------------------------------------*/
.KeysHome #preloader {
  position: fixed;
  inset: 0;
  z-index: 999999;
  overflow: hidden;
  background: var(--background-color);
  transition: all 0.6s ease-out;
}

.KeysHome #preloader:before {
  content: "";
  position: fixed;
  top: calc(50% - 30px);
  left: calc(50% - 30px);
  border: 6px solid #ffffff;
  border-color: var(--accent-color) transparent var(--accent-color) transparent;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: animate-preloader 1.5s linear infinite;
}

@keyframes animate-preloader {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

/*--------------------------------------------------------------
# Scroll Top Button
--------------------------------------------------------------*/
.KeysHome .scroll-top {
  position: fixed;
  visibility: hidden;
  opacity: 0;
  right: 15px;
  bottom: 15px;
  z-index: 99999;
  background-color: var(--accent-color);
  width: 40px;
  height: 40px;
  border-radius: 4px;
  transition: all 0.4s;
}

.KeysHome .scroll-top i {
  font-size: 24px;
  color: var(--default-color);
  line-height: 0;
}

.KeysHome .scroll-top:hover {
  background-color: color-mix(in srgb, var(--accent-color), transparent 20%);
  color: var(--contrast-color);
}

.KeysHome .scroll-top.active {
  visibility: visible;
  opacity: 1;
}

/*--------------------------------------------------------------
# Disable aos animation delay on mobile devices
--------------------------------------------------------------*/
@media screen and (max-width: 768px) {
  .KeysHome [data-aos-delay] {
    transition-delay: 0 !important;
  }
}

/*--------------------------------------------------------------
# Global Page Titles & Breadcrumbs
--------------------------------------------------------------*/
.KeysHome .page-title {
  color: var(--default-color);
  background-color: var(--background-color);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 160px 0 60px 0;
  text-align: center;
  position: relative;
}

.KeysHome .page-title:before {
  content: "";
  background-color: color-mix(in srgb, var(--background-color), transparent 40%);
  position: absolute;
  inset: 0;
}

.KeysHome .page-title h1 {
  font-size: 56px;
  font-weight: 500;
  margin-bottom: 10px;
}

.KeysHome .page-title .breadcrumbs ol {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  justify-content: center;
  padding: 0;
  margin: 0;
  font-size: 16px;
  font-weight: 500;
}

.KeysHome .page-title .breadcrumbs ol li + li {
  padding-left: 10px;
}

.KeysHome .page-title .breadcrumbs ol li + li::before {
  content: "/";
  display: inline-block;
  padding-right: 10px;
  color: color-mix(in srgb, var(--default-color), transparent 20%);
}

/*--------------------------------------------------------------
# Global Sections
--------------------------------------------------------------*/
.KeysHome section,
.KeysHome .section {
  color: var(--default-color) !important;
  background-color: var(--background-color) !important;
  padding: 60px 0;
  scroll-margin-top: 92px;
  overflow: clip;
}

@media (max-width: 1199px) {
  .KeysHome section,
  .KeysHome .section {
    scroll-margin-top: 76px;
  }
}

/*--------------------------------------------------------------
# Global Section Titles
--------------------------------------------------------------*/
.KeysHome .section-title {
  text-align: center;
  padding-bottom: 60px;
  position: relative;
}

.KeysHome .section-title h2 {
  font-size: 32px;
  font-weight: 700;
  position: relative;
}

.KeysHome .section-title h2:before,
.KeysHome .section-title h2:after {
  content: "";
  width: 50px;
  height: 2px;
  background: var(--accent-color);
  display: inline-block;
}

.KeysHome .section-title h2:before {
  margin: 0 15px 10px 0;
}

.KeysHome .section-title h2:after {
  margin: 0 0 10px 15px;
}

.KeysHome .section-title p {
  margin-bottom: 0;
}

/*--------------------------------------------------------------
# Hero Section
--------------------------------------------------------------*/
.KeysHome .hero {
  width: 100%;
  min-height: 100vh;
  position: relative;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.6);
}

.KeysHome .header {
  padding: 10px 0px !important;
}

.KeysHome .header.sticked {
  /* background-color: white !important; */
  box-shadow: 0px 0 18px rgba(0, 0, 0, 0.4);
  color: var(--default-color);
  background-color: white !important;
  padding: 40px 0 !important;
  transition: all 0.5s;
  z-index: 997 !important;
}

.KeysHome .header.sticked a,
.KeysHome .header.sticked h1 {
  color: black !important;
}

.KeysHome .hero .info {
  position: relative;
  inset: 0;
  z-index: 3;
  padding: 140px 0 60px 0;
}

@media (max-width: 768px), (max-height: 480px) {
  .KeysHome .hero .info {
    padding: 100px 50px 60px 50px;
  }
}

.KeysHome .hero .info h2 {
  margin-bottom: 30px;
  color: white !important;
  padding-bottom: 30px;
  font-size: 56px;
  font-weight: 700;
  position: relative;
}

.KeysHome .hero .info h2:after {
  content: "";
  position: absolute;
  display: block;
  width: 80px;
  height: 4px;
  background: var(--accent-color);
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}

@media (max-width: 768px) {
  .KeysHome .hero .info h2 {
    font-size: 36px;
  }
}

.KeysHome .hero .info p {
  color: rgb(211, 208, 208);
  font-size: 18px;
}

.KeysHome .hero .info .btn-get-started {
  color: var(--contrast-color);
  font-family: var(--heading-font);
  font-weight: 500;
  font-size: 16px;
  letter-spacing: 1px;
  display: inline-block;
  padding: 12px 40px;
  border-radius: 50px;
  transition: 0.5s;
  margin: 10px;
  border: 2px solid var(--accent-color);
}

.KeysHome .hero .info .btn-get-started:hover {
  background: var(--accent-color);
}

.KeysHome .hero .swiper {
  inset: 0;
  position: absolute;
  overflow: hidden;
  width: 100%;
  height: 100%;
  z-index: -1;
}

.KeysHome .hero .carousel-item {
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  overflow: hidden;
  transition-duration: 0.4s;
}

.KeysHome .hero .carousel-item img {
  position: absolute;
  inset: 0;
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 1;
}

.KeysHome .hero .carousel-item::before {
  content: "";
  background-color: color-mix(in srgb, var(--background-color), transparent 30%);
  position: absolute;
  inset: 0;
  z-index: 2;
}

.KeysHome .hero .carousel-control-prev {
  justify-content: start;
}

@media (min-width: 640px) {
  .KeysHome .hero .carousel-control-prev {
    padding-left: 15px;
  }
}

.KeysHome .hero .carousel-control-next {
  justify-content: end;
}

@media (min-width: 640px) {
  .KeysHome .hero .carousel-control-next {
    padding-right: 15px;
  }
}

.KeysHome .hero .carousel-control-next-icon,
.KeysHome .hero .carousel-control-prev-icon {
  background: none;
  font-size: 26px;
  line-height: 0;
  background: color-mix(in srgb, var(--default-color), transparent 80%);
  color: color-mix(in srgb, var(--default-color), transparent 40%);
  border-radius: 50px;
  width: 54px;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.KeysHome .hero .carousel-control-prev,
.KeysHome .hero .carousel-control-next {
  z-index: 3;
  transition: 0.3s;
}

.KeysHome .hero .carousel-control-prev:focus,
.KeysHome .hero .carousel-control-next:focus {
  opacity: 0.5;
}

.KeysHome .hero .carousel-control-prev:hover,
.KeysHome .hero .carousel-control-next:hover {
  opacity: 0.9;
}

/*--------------------------------------------------------------
# Get Started Section
--------------------------------------------------------------*/
.KeysHome .get-started .content {
  padding: 30px 0;
}

.KeysHome .get-started .content h3 {
  font-size: 36px;
  font-weight: 600;
  margin-bottom: 25px;
  padding-bottom: 25px;
  position: relative;
}

.KeysHome .get-started .content h3:after {
  content: "";
  position: absolute;
  display: block;
  width: 60px;
  height: 4px;
  background: var(--accent-color);
  left: 0;
  bottom: 0;
}

.KeysHome .get-started .content p {
  font-size: 14px;
}

.KeysHome .get-started .php-email-form {
  background: color-mix(in srgb, var(--default-color), transparent 97%);
  padding: 30px;
  height: 100%;
}

@media (max-width: 575px) {
  .KeysHome .get-started .php-email-form {
    padding: 20px;
  }
}

.KeysHome .get-started .php-email-form h3 {
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.KeysHome .get-started .php-email-form p {
  font-size: 14px;
  margin-bottom: 20px;
}

.KeysHome .get-started .php-email-form input[type="text"],
.KeysHome .get-started .php-email-form input[type="email"],
.KeysHome .get-started .php-email-form textarea {
  font-size: 14px;
  padding: 10px 15px;
  box-shadow: none;
  border-radius: 0;
  color: var(--default-color);
  background-color: color-mix(in srgb, var(--background-color), transparent 20%);
  border-color: color-mix(in srgb, var(--default-color), transparent 80%);
}

.KeysHome .get-started .php-email-form input[type="text"]:focus,
.KeysHome .get-started .php-email-form input[type="email"]:focus,
.KeysHome .get-started .php-email-form textarea:focus {
  border-color: var(--accent-color);
}

.KeysHome .get-started .php-email-form input[type="text"]::placeholder,
.KeysHome .get-started .php-email-form input[type="email"]::placeholder,
.KeysHome .get-started .php-email-form textarea::placeholder {
  color: color-mix(in srgb, var(--default-color), transparent 70%);
}

.KeysHome .get-started .php-email-form button[type="submit"] {
  color: var(--contrast-color);
  background: var(--accent-color);
  border: 0;
  padding: 10px 30px;
  transition: 0.4s;
  border-radius: 4px;
}

.KeysHome .get-started .php-email-form button[type="submit"]:hover {
  background: color-mix(in srgb, var(--accent-color), transparent 20%);
}

/*--------------------------------------------------------------
# Constructions Section
--------------------------------------------------------------*/
.KeysHome .constructions .card-item {
  background-color: var(--surface-color);
  border: 1px solid color-mix(in srgb, var(--default-color), transparent 85%);
  position: relative;
  border-radius: 0;
}

.KeysHome .constructions .card-item .card-bg {
  min-height: 300px;
  position: relative;
}

.KeysHome .constructions .card-item .card-bg img {
  position: absolute;
  inset: 0;
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  z-index: 1;
}

.KeysHome .constructions .card-item .card-body {
  padding: 30px;
}

.KeysHome .constructions .card-item h4 {
  font-weight: 700;
  font-size: 20px;
  margin-bottom: 15px;
}

.KeysHome .constructions .card-item p {
  color: color-mix(in srgb, var(--default-color), transparent 40%);
  margin: 0;
}

/*--------------------------------------------------------------
# Services Section
--------------------------------------------------------------*/
.KeysHome .services .service-item {
  background-color: var(--surface-color);
  padding: 40px;
  box-shadow: 0px 0 30px rgba(0, 0, 0, 0.1);
  height: 100%;
}

.KeysHome .services .service-item .icon {
  width: 48px;
  height: 48px;
  position: relative;
  margin-bottom: 50px;
}

.KeysHome .services .service-item .icon svg {
  color: var(--heading-color);
  font-size: 54px;
  transition: ease-in-out 0.3s;
  z-index: 2;
  position: relative;
}

.KeysHome .services .service-item .icon {
  display: flex;
  width: 80px;
  height: 80px;
  justify-content: center;
  align-items: center;
  background: color-mix(in srgb, var(--heading-color), transparent 95%);
  border-radius: 50px;
  transition: 0.3s;
}

.KeysHome .services .service-item h3 {
  color: color-mix(in srgb, var(--heading-color), transparent 20%);
  font-weight: 700;
  margin: 0 0 20px 0;
  padding-bottom: 8px;
  font-size: 22px;
  position: relative;
  display: inline-block;
  border-bottom: 4px solid color-mix(in srgb, var(--heading-color), transparent 90%);
  transition: 0.3s;
}

.KeysHome .services .service-item p {
  line-height: 24px;
  font-size: 14px;
  margin-bottom: 0;
}

.KeysHome .services .service-item .readmore {
  margin-top: 15px;
  display: inline-block;
  color: color-mix(in srgb, var(--default-color), transparent 30%);
}

.KeysHome .services .service-item:hover .icon i {
  color: var(--heading-color);
}

.KeysHome .services .service-item:hover .icon:before {
  background: var(--accent-color);
}

.KeysHome .services .service-item:hover h3 {
  border-color: var(--accent-color);
  color: var(--heading-color);
}

.KeysHome .services .service-item:hover .readmore {
  color: var(--accent-color);
}

/*--------------------------------------------------------------
# Alt Services Section
--------------------------------------------------------------*/
.KeysHome .alt-services .features-image {
  position: relative;
  min-height: 400px;
}

.KeysHome .alt-services .features-image img {
  position: absolute;
  inset: 0;
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 1;
}

.KeysHome .alt-services h3 {
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 20px;
  padding-bottom: 20px;
  position: relative;
}

.KeysHome .alt-services h3:after {
  content: "";
  background: var(--accent-color);
  position: absolute;
  display: block;
  width: 50px;
  height: 3px;
  left: 0;
  bottom: 0;
}

.KeysHome .alt-services .icon-box {
  margin-top: 50px;
}

.KeysHome .alt-services .icon-box svg {
  color: var(--accent-color);
  background-color: var(--surface-color);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 25px;
  font-size: 28px;
  width: 56px;
  height: 56px;
  border-radius: 4px;
  line-height: 0;
  box-shadow: 0px 2px 30px rgba(0, 0, 0, 0.1);
  transition: 0.3s;
}

.KeysHome .alt-services .icon-box:hover svg {
  background-color: var(--accent-color);
  color: var(--contrast-color);
}

.KeysHome .alt-services .icon-box h4 {
  font-weight: 700;
  margin-bottom: 10px;
  font-size: 18px;
}

.KeysHome .alt-services .icon-box h4 a {
  color: var(--heading-color);
  transition: 0.3s;
}

.KeysHome .alt-services .icon-box h4 a:hover {
  color: var(--accent-color);
}

.KeysHome .alt-services .icon-box p {
  line-height: 24px;
  font-size: 14px;
  margin-bottom: 0;
}

/*--------------------------------------------------------------
# Features Section
--------------------------------------------------------------*/
.KeysHome .features .nav-tabs {
  border: 0;
}

.KeysHome .features .nav-link {
  color: var(--heading-color);
  padding: 15px 0;
  transition: 0.3s;
  border-radius: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  height: 100%;
  border: 0;
  border-bottom: 4px solid color-mix(in srgb, var(--default-color), transparent 90%);
}

.KeysHome .features .nav-link i {
  padding-right: 15px;
  font-size: 48px;
}

.KeysHome .features .nav-link h4 {
  font-size: 18px;
  font-weight: 600;
  margin: 0;
}

@media (max-width: 575px) {
  .KeysHome .features .nav-link h4 {
    font-size: 16px;
  }
}

.KeysHome .features .nav-link:hover {
  color: var(--accent-color);
  border-color: color-mix(in srgb, var(--default-color), transparent 80%);
}

.KeysHome .features .nav-link.active {
  background-color: var(--background-color);
  color: var(--accent-color);
  border-color: var(--accent-color);
}

.KeysHome .features .tab-content {
  margin-top: 30px;
}

.KeysHome .features .features-tabs h3 {
  color: var(--heading-color);
  font-weight: 700;
  font-size: 32px;
  position: relative;
  margin-bottom: 20px;
  padding-bottom: 20px;
}

.KeysHome .features .features-tabs h3:after {
  content: "";
  position: absolute;
  display: block;
  width: 60px;
  height: 3px;
  background: var(--accent-color);
  left: 0;
  bottom: 0;
}

.KeysHome .features .features-tabs ul {
  list-style: none;
  padding: 0;
}

.KeysHome .features .features-tabs ul li {
  padding-top: 10px;
}

.KeysHome .features .features-tabs ul svg {
  font-size: 20px;
  padding-right: 4px;
  color: var(--accent-color);
}

.KeysHome .features .features-tabs p:last-child {
  margin-bottom: 0;
}

/*--------------------------------------------------------------
# Projects Section
--------------------------------------------------------------*/
.KeysHome .projects .portfolio-filters {
  padding: 0;
  margin: 0 auto 20px auto;
  list-style: none;
  text-align: center;
}

.KeysHome .projects .portfolio-filters li {
  cursor: pointer;
  display: inline-block;
  padding: 0;
  font-size: 18px;
  font-weight: 500;
  margin: 0 10px;
  line-height: 1;
  margin-bottom: 5px;
  transition: all 0.3s ease-in-out;
}

.KeysHome .projects .portfolio-filters li:hover,
.KeysHome .projects .portfolio-filters li.filter-active {
  color: var(--accent-color);
}

.KeysHome .projects .portfolio-filters li:first-child {
  margin-left: 0;
}

.KeysHome .projects .portfolio-filters li:last-child {
  margin-right: 0;
}

@media (max-width: 575px) {
  .KeysHome .projects .portfolio-filters li {
    font-size: 14px;
    margin: 0 5px;
  }
}

.KeysHome .projects .portfolio-content {
  position: relative;
  overflow: hidden;
}

.KeysHome .projects .portfolio-content img {
  transition: 0.3s;
}

.KeysHome .projects .portfolio-content .portfolio-info {
  opacity: 0;
  position: absolute;
  inset: 0;
  z-index: 3;
  transition: all ease-in-out 0.3s;
  background: rgba(0, 0, 0, 0.6);
  padding: 15px;
}

.KeysHome .projects .portfolio-content .portfolio-info h4 {
  font-size: 14px;
  padding: 5px 10px;
  font-weight: 400;
  color: #ffffff;
  display: inline-block;
  background-color: var(--accent-color);
}

.KeysHome .projects .portfolio-content .portfolio-info p {
  position: absolute;
  bottom: 10px;
  text-align: center;
  display: inline-block;
  left: 0;
  right: 0;
  font-size: 16px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.8);
}

.KeysHome .projects .portfolio-content .portfolio-info .preview-link,
.KeysHome .projects .portfolio-content .portfolio-info .details-link {
  position: absolute;
  left: calc(50% - 40px);
  font-size: 26px;
  top: calc(50% - 14px);
  color: #fff;
  transition: 0.3s;
  line-height: 1.2;
}

.KeysHome .projects .portfolio-content .portfolio-info .preview-link:hover,
.KeysHome .projects .portfolio-content .portfolio-info .details-link:hover {
  color: var(--accent-color);
}

.KeysHome .projects .portfolio-content .portfolio-info .details-link {
  left: 50%;
  font-size: 34px;
  line-height: 0;
}

.KeysHome .projects .portfolio-content:hover .portfolio-info {
  opacity: 1;
}

.KeysHome .projects .portfolio-content:hover img {
  transform: scale(1.1);
}

/*--------------------------------------------------------------
# Testimonials Section
--------------------------------------------------------------*/
.KeysHome .testimonials .testimonial-wrap {
  padding-left: 50px;
}

.KeysHome .testimonials .testimonials-carousel,
.KeysHome .testimonials .testimonials-slider {
  overflow: hidden;
}

.KeysHome .testimonials .testimonial-item {
  background-color: var(--surface-color);
  box-shadow: 0px 2px 15px rgba(0, 0, 0, 0.1);
  box-sizing: content-box;
  padding: 30px 30px 30px 60px;
  margin: 30px 15px;
  min-height: 200px;
  position: relative;
}

.KeysHome .testimonials .testimonial-item .testimonial-img {
  width: 90px;
  border-radius: 10px;
  border: 6px solid var(--background-color);
  position: absolute;
  left: -45px;
}

.KeysHome .testimonials .testimonial-item h3 {
  font-size: 18px;
  font-weight: bold;
  margin: 10px 0 5px 0;
}

.KeysHome .testimonials .testimonial-item h4 {
  color: color-mix(in srgb, var(--default-color), transparent 50%);
  font-size: 14px;
  margin: 0;
}

.KeysHome .testimonials .testimonial-item .stars {
  margin: 10px 0;
}

.KeysHome .testimonials .testimonial-item .stars i {
  color: #ffc107;
  margin: 0 1px;
}

.KeysHome .testimonials .testimonial-item .quote-icon-left,
.KeysHome .testimonials .testimonial-item .quote-icon-right {
  color: color-mix(in srgb, var(--accent-color), transparent 60%);
  font-size: 26px;
  line-height: 0;
}

.KeysHome .testimonials .testimonial-item .quote-icon-left {
  display: inline-block;
  left: -5px;
  position: relative;
}

.KeysHome .testimonials .testimonial-item .quote-icon-right {
  display: inline-block;
  right: -5px;
  position: relative;
  top: 10px;
  transform: scale(-1, -1);
}

.KeysHome .testimonials .testimonial-item p {
  font-style: italic;
  margin: 15px auto 15px auto;
}

.KeysHome .testimonials .swiper-wrapper {
  height: auto;
}

.KeysHome .testimonials .swiper-pagination {
  margin-top: 20px;
  position: relative;
}

.KeysHome .testimonials .swiper-pagination .swiper-pagination-bullet {
  width: 12px;
  height: 12px;
  background-color: var(--background-color);
  opacity: 1;
  border: 1px solid var(--accent-color);
}

.KeysHome .testimonials .swiper-pagination .swiper-pagination-bullet-active {
  background-color: var(--accent-color);
}

@media (max-width: 767px) {
  .KeysHome .testimonials .testimonial-wrap {
    padding-left: 0;
  }

  .KeysHome .testimonials .testimonials-carousel,
  .KeysHome .testimonials .testimonials-slider {
    overflow: hidden;
  }

  .KeysHome .testimonials .testimonial-item {
    padding: 30px;
    margin: 15px;
  }

  .KeysHome .testimonials .testimonial-item .testimonial-img {
    position: static;
    left: auto;
  }
}

/*--------------------------------------------------------------
# Recent Blog Posts Section
--------------------------------------------------------------*/
.KeysHome .recent-blog-posts .post-item {
  background: var(--surface-color);
  box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.1);
  transition: 0.3s;
}

.KeysHome .recent-blog-posts .post-item .post-img img {
  transition: 0.5s;
}

.KeysHome .recent-blog-posts .post-item .post-date {
  position: absolute;
  right: 0;
  bottom: 0;
  background-color: var(--accent-color);
  color: var(--contrast-color);
  text-transform: uppercase;
  font-size: 13px;
  padding: 6px 12px;
  font-weight: 500;
}

.KeysHome .recent-blog-posts .post-item .post-content {
  padding: 30px;
}

.KeysHome .recent-blog-posts .post-item .post-title {
  color: var(--heading-color);
  font-size: 20px;
  font-weight: 700;
  transition: 0.3s;
  margin-bottom: 15px;
}

.KeysHome .recent-blog-posts .post-item .meta i {
  font-size: 16px;
  color: var(--accent-color);
}

.KeysHome .recent-blog-posts .post-item .meta span {
  font-size: 15px;
  color: color-mix(in srgb, var(--default-color), transparent 50%);
}

.KeysHome .recent-blog-posts .post-item hr {
  color: color-mix(in srgb, var(--default-color), transparent 80%);
  margin: 20px 0;
}

.KeysHome .recent-blog-posts .post-item .readmore {
  display: flex;
  align-items: center;
  font-weight: 600;
  line-height: 1;
  transition: 0.3s;
  color: color-mix(in srgb, var(--default-color), transparent 40%);
}

.KeysHome .recent-blog-posts .post-item .readmore i {
  line-height: 0;
  margin-left: 6px;
  font-size: 16px;
}

.KeysHome .recent-blog-posts .post-item:hover .post-title,
.KeysHome .recent-blog-posts .post-item:hover .readmore {
  color: var(--accent-color);
}

.KeysHome .recent-blog-posts .post-item:hover .post-img img {
  transform: scale(1.1);
}

/*--------------------------------------------------------------
# About Section
--------------------------------------------------------------*/
.KeysHome .about .inner-title {
  font-size: 2.75rem;
  font-weight: 700;
  margin: 30px 0;
}

@media (min-width: 991px) {
  .KeysHome .about .inner-title {
    max-width: 65%;
    margin: 0 0 80px 0;
  }
}

.KeysHome .about .our-story {
  padding: 40px;
  background-color: color-mix(in srgb, var(--default-color), transparent 96%);
}

@media (min-width: 991px) {
  .KeysHome .about .our-story {
    padding-right: 35%;
  }
}

.KeysHome .about .our-story h4 {
  text-transform: uppercase;
  font-size: 1.1rem;
  color: color-mix(in srgb, var(--default-color), transparent 50%);
}

.KeysHome .about .our-story h3 {
  font-size: 2.25rem;
  font-weight: 700;
  color: color-mix(in srgb, var(--default-color), transparent 20%);
}

.KeysHome .about .our-story p:last-child {
  margin-bottom: 0;
}

.KeysHome .about ul {
  list-style: none;
  padding: 0;
  font-size: 15px;
}

.KeysHome .about ul li {
  padding: 5px 0;
  display: flex;
  align-items: center;
}

.KeysHome .about ul i {
  font-size: 1.25rem;
  margin-right: 0.5rem;
  line-height: 1.2;
  color: var(--accent-color);
}

.KeysHome .about .watch-video i {
  font-size: 2rem;
  transition: 0.3s;
  color: var(--accent-color);
}

.KeysHome .about .watch-video a {
  font-weight: 600;
  color: color-mix(in srgb, var(--default-color), transparent 20%);
  margin-left: 8px;
  transition: 0.3s;
}

.KeysHome .about .watch-video:hover a {
  color: var(--accent-color);
}

.KeysHome .about .about-img {
  min-height: 400px;
  position: relative;
}

@media (min-width: 992px) {
  .KeysHome .about .about-img {
    position: absolute;
    top: 0;
    right: 0;
    min-height: 600px;
  }
}

.KeysHome .about .about-img img {
  position: absolute;
  inset: 0;
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  z-index: 1;
}

/*--------------------------------------------------------------
# Stats Counter Section
--------------------------------------------------------------*/
.KeysHome .stats-counter .stats-item {
  box-shadow: 0px 0 30px rgba(0, 0, 0, 0.1);
  padding: 30px;
}

.KeysHome .stats-counter .stats-item i {
  color: var(--accent-color);
  font-size: 42px;
  line-height: 0;
  margin-right: 20px;
}

.KeysHome .stats-counter .stats-item span {
  color: var(--heading-color);
  font-size: 36px;
  display: block;
  font-weight: 600;
}

.KeysHome .stats-counter .stats-item p {
  padding: 0;
  margin: 0;
  font-family: var(--heading-font);
  font-size: 16px;
}

/*--------------------------------------------------------------
# Alt Services 2 Section
--------------------------------------------------------------*/
.KeysHome .alt-services-2 .features-image {
  position: relative;
  min-height: 400px;
}

.KeysHome .alt-services-2 .features-image img {
  position: absolute;
  inset: 0;
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 1;
}

.KeysHome .alt-services-2 h3 {
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 20px;
}

.KeysHome .alt-services-2 .icon-box {
  margin-top: 30px;
}

.KeysHome .alt-services-2 .icon-box i {
  color: var(--accent-color);
  margin-right: 15px;
  font-size: 24px;
  line-height: 1.2;
}

.KeysHome .alt-services-2 .icon-box h4 {
  font-weight: 600;
  margin-bottom: 10px;
  font-size: 18px;
}

.KeysHome .alt-services-2 .icon-box p {
  line-height: 24px;
  font-size: 14px;
  margin-bottom: 0;
}

/*--------------------------------------------------------------
# Team Section
--------------------------------------------------------------*/
.KeysHome .team .member {
  position: relative;
}

.KeysHome .team .member .member-img {
  margin: 0 80px;
  border-radius: 50%;
  overflow: hidden;
  position: relative;
}

@media (max-width: 1024px) {
  .KeysHome .team .member .member-img {
    margin: 0 60px;
  }
}

.KeysHome .team .member .member-img img {
  position: relative;
  z-index: 1;
}

.KeysHome .team .member .member-img .social {
  position: absolute;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
  padding-bottom: 20px;
  transition: 0.3s;
  visibility: hidden;
  opacity: 0;
}

.KeysHome .team .member .member-img .social a {
  transition: 0.3s;
  color: var(--contrast-color);
  font-size: 20px;
  margin: 0 8px;
}

.KeysHome .team .member .member-img .social a:hover {
  color: var(--accent-color);
}

.KeysHome .team .member .member-info {
  margin-top: 30px;
}

.KeysHome .team .member .member-info h4 {
  font-weight: 700;
  margin-bottom: 6px;
  font-size: 18px;
}

.KeysHome .team .member .member-info span {
  font-style: italic;
  display: block;
  font-size: 15px;
  color: color-mix(in srgb, var(--default-color), transparent 40%);
  margin-bottom: 10px;
}

.KeysHome .team .member .member-info p {
  margin-bottom: 0;
  font-size: 14px;
}

.KeysHome .team .member:hover .member-img .social {
  padding-bottom: 0;
  visibility: visible;
  opacity: 1;
}

/*--------------------------------------------------------------
# Features Cards Section
--------------------------------------------------------------*/
.KeysHome .features-cards h3 {
  font-size: 20px;
  font-weight: 700;
}

.KeysHome .features-cards p {
  font-size: 15px;
  color: color-mix(in srgb, var(--default-color), transparent 20%);
}

.KeysHome .features-cards ul li {
  display: flex;
  align-items: center;
  font-size: 14px;
  padding-top: 10px;
  color: color-mix(in srgb, var(--default-color), transparent 30%);
}

.KeysHome .features-cards ul li i {
  font-size: 16px;
  color: var(--accent-color);
  margin-right: 6px;
}

/*--------------------------------------------------------------
# Service Details Section
--------------------------------------------------------------*/
.KeysHome .service-details .services-list {
  background-color: var(--surface-color);
  padding: 10px 30px;
  border: 1px solid color-mix(in srgb, var(--default-color), transparent 90%);
  margin-bottom: 20px;
}

.KeysHome .service-details .services-list a {
  display: block;
  line-height: 1;
  padding: 8px 0 8px 15px;
  border-left: 3px solid color-mix(in srgb, var(--default-color), transparent 70%);
  margin: 20px 0;
  color: color-mix(in srgb, var(--default-color), transparent 20%);
  transition: 0.3s;
}

.KeysHome .service-details .services-list a.active {
  color: var(--heading-color);
  font-weight: 700;
  border-color: var(--accent-color);
}

.KeysHome .service-details .services-list a:hover {
  border-color: var(--accent-color);
}

.KeysHome .service-details .services-img {
  margin-bottom: 20px;
}

.KeysHome .service-details h3 {
  font-size: 26px;
  font-weight: 700;
}

.KeysHome .service-details h4 {
  font-size: 20px;
  font-weight: 700;
}

.KeysHome .service-details p {
  font-size: 15px;
}

.KeysHome .service-details ul {
  list-style: none;
  padding: 0;
  font-size: 15px;
}

.KeysHome .service-details ul li {
  padding: 5px 0;
  display: flex;
  align-items: center;
}

.KeysHome .service-details ul i {
  font-size: 20px;
  margin-right: 8px;
  color: var(--accent-color);
}

/*--------------------------------------------------------------
# Project Details Section
--------------------------------------------------------------*/
.KeysHome .project-details .portfolio-details-slider img {
  width: 100%;
}

.KeysHome .project-details .swiper-wrapper {
  height: auto;
}

.KeysHome .project-details .swiper-button-prev,
.KeysHome .project-details .swiper-button-next {
  width: 48px;
  height: 48px;
}

.KeysHome .project-details .swiper-button-prev:after,
.KeysHome .project-details .swiper-button-next:after {
  color: rgba(255, 255, 255, 0.8);
  background-color: rgba(0, 0, 0, 0.15);
  font-size: 24px;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.3s;
}

.KeysHome .project-details .swiper-button-prev:hover:after,
.KeysHome .project-details .swiper-button-next:hover:after {
  background-color: rgba(0, 0, 0, 0.3);
}

@media (max-width: 575px) {
  .KeysHome .project-details .swiper-button-prev,
  .KeysHome .project-details .swiper-button-next {
    display: none;
  }
}

.KeysHome .project-details .swiper-pagination {
  margin-top: 20px;
  position: relative;
}

.KeysHome .project-details .swiper-pagination .swiper-pagination-bullet {
  width: 10px;
  height: 10px;
  background-color: color-mix(in srgb, var(--default-color), transparent 85%);
  opacity: 1;
}

.KeysHome .project-details .swiper-pagination .swiper-pagination-bullet-active {
  background-color: var(--accent-color);
}

.KeysHome .project-details .portfolio-info h3 {
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 20px;
  padding-bottom: 20px;
  position: relative;
}

.KeysHome .project-details .portfolio-info h3:after {
  content: "";
  position: absolute;
  display: block;
  width: 50px;
  height: 3px;
  background: var(--accent-color);
  left: 0;
  bottom: 0;
}

.KeysHome .project-details .portfolio-info ul {
  list-style: none;
  padding: 0;
  font-size: 15px;
}

.KeysHome .project-details .portfolio-info ul li {
  display: flex;
  flex-direction: column;
  padding-bottom: 15px;
}

.KeysHome .project-details .portfolio-info ul strong {
  text-transform: uppercase;
  font-weight: 400;
  color: color-mix(in srgb, var(--default-color), transparent 50%);
  font-size: 14px;
}

.KeysHome .project-details .portfolio-info .btn-visit {
  padding: 8px 40px;
  background: var(--accent-color);
  color: var(--contrast-color);
  border-radius: 50px;
  transition: 0.3s;
}

.KeysHome .project-details .portfolio-info .btn-visit:hover {
  background: color-mix(in srgb, var(--accent-color), transparent 20%);
}

.KeysHome .project-details .portfolio-description h2 {
  font-size: 26px;
  font-weight: 700;
  margin-bottom: 20px;
}

.KeysHome .project-details .portfolio-description p {
  padding: 0;
}

.KeysHome .project-details .portfolio-description .testimonial-item {
  padding: 30px 30px 0 30px;
  position: relative;
  background: color-mix(in srgb, var(--default-color), transparent 97%);
  margin-bottom: 50px;
}

.KeysHome .project-details .portfolio-description .testimonial-item .testimonial-img {
  width: 90px;
  border-radius: 50px;
  border: 6px solid var(--background-color);
  float: left;
  margin: 0 10px 0 0;
}

.KeysHome .project-details .portfolio-description .testimonial-item h3 {
  font-size: 18px;
  font-weight: bold;
  margin: 15px 0 5px 0;
  padding-top: 20px;
}

.KeysHome .project-details .portfolio-description .testimonial-item h4 {
  font-size: 14px;
  color: #6c757d;
  margin: 0;
}

.KeysHome .project-details .portfolio-description .testimonial-item .quote-icon-left,
.KeysHome .project-details .portfolio-description .testimonial-item .quote-icon-right {
  color: color-mix(in srgb, var(--accent-color), transparent 50%);
  font-size: 26px;
  line-height: 0;
}

.KeysHome .project-details .portfolio-description .testimonial-item .quote-icon-left {
  display: inline-block;
  left: -5px;
  position: relative;
}

.KeysHome .project-details .portfolio-description .testimonial-item .quote-icon-right {
  display: inline-block;
  right: -5px;
  position: relative;
  top: 10px;
  transform: scale(-1, -1);
}

.KeysHome .project-details .portfolio-description .testimonial-item p {
  font-style: italic;
  margin: 0 0 15px 0 0 0;
  padding: 0;
}

/*--------------------------------------------------------------
# Blog Posts Section
--------------------------------------------------------------*/
.KeysHome .blog-posts article {
  background-color: var(--surface-color);
  box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.1);
  transition: 0.3s;
}

.KeysHome .blog-posts .post-img img {
  transition: 0.5s;
}

.KeysHome .blog-posts .post-date {
  background-color: var(--accent-color);
  color: var(--contrast-color);
  position: absolute;
  right: 0;
  bottom: 0;
  text-transform: uppercase;
  font-size: 13px;
  padding: 6px 12px;
  font-weight: 500;
}

.KeysHome .blog-posts .post-content {
  padding: 30px;
}

.KeysHome .blog-posts .post-title {
  font-size: 20px;
  color: var(--heading-color);
  font-weight: 700;
  transition: 0.3s;
  margin-bottom: 15px;
}

.KeysHome .blog-posts .meta i {
  font-size: 16px;
  color: var(--accent-color);
}

.KeysHome .blog-posts .meta span {
  font-size: 15px;
  color: color-mix(in srgb, var(--default-color), transparent 40%);
}

.KeysHome .blog-posts p {
  margin-top: 20px;
}

.KeysHome .blog-posts hr {
  color: color-mix(in srgb, var(--default-color), transparent 60%);
  margin-bottom: 15px;
}

.KeysHome .blog-posts .readmore {
  display: flex;
  align-items: center;
  font-weight: 600;
  line-height: 1;
  transition: 0.3s;
  color: color-mix(in srgb, var(--heading-color), transparent 20%);
}

.KeysHome .blog-posts .readmore i {
  line-height: 0;
  margin-left: 6px;
  font-size: 16px;
}

.KeysHome .blog-posts article:hover .post-title,
.KeysHome .blog-posts article:hover .readmore {
  color: var(--accent-color);
}

.KeysHome .blog-posts article:hover .post-img img {
  transform: scale(1.1);
}

/*--------------------------------------------------------------
# Blog Pagination Section
--------------------------------------------------------------*/
.KeysHome .blog-pagination {
  padding-top: 0;
  color: color-mix(in srgb, var(--default-color), transparent 40%);
}

.KeysHome .blog-pagination ul {
  display: flex;
  padding: 0;
  margin: 0;
  list-style: none;
}

.KeysHome .blog-pagination li {
  margin: 0 5px;
  transition: 0.3s;
}

.KeysHome .blog-pagination li a {
  color: color-mix(in srgb, var(--default-color), transparent 40%);
  padding: 7px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.KeysHome .blog-pagination li a.active,
.KeysHome .blog-pagination li a:hover {
  background: var(--accent-color);
  color: var(--contrast-color);
}

.KeysHome .blog-pagination li a.active a,
.KeysHome .blog-pagination li a:hover a {
  color: var(--contrast-color);
}

/*--------------------------------------------------------------
# Blog Details Section
--------------------------------------------------------------*/
.KeysHome .blog-details {
  padding-bottom: 30px;
}

.KeysHome .blog-details .article {
  background-color: var(--surface-color);
  padding: 30px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.KeysHome .blog-details .post-img {
  margin: -30px -30px 20px -30px;
  overflow: hidden;
}

.KeysHome .blog-details .title {
  color: var(--heading-color);
  font-size: 28px;
  font-weight: 700;
  padding: 0;
  margin: 30px 0;
}

.KeysHome .blog-details .content {
  margin-top: 20px;
}

.KeysHome .blog-details .content h3 {
  font-size: 22px;
  margin-top: 30px;
  font-weight: bold;
}

.KeysHome .blog-details .content blockquote {
  overflow: hidden;
  background-color: color-mix(in srgb, var(--default-color), transparent 95%);
  padding: 60px;
  position: relative;
  text-align: center;
  margin: 20px 0;
}

.KeysHome .blog-details .content blockquote p {
  color: var(--default-color);
  line-height: 1.6;
  margin-bottom: 0;
  font-style: italic;
  font-weight: 500;
  font-size: 22px;
}

.KeysHome .blog-details .content blockquote:after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background-color: var(--accent-color);
  margin-top: 20px;
  margin-bottom: 20px;
}

.KeysHome .blog-details .meta-top {
  margin-top: 20px;
  color: color-mix(in srgb, var(--default-color), transparent 40%);
}

.KeysHome .blog-details .meta-top ul {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  align-items: center;
  padding: 0;
  margin: 0;
}

.KeysHome .blog-details .meta-top ul li + li {
  padding-left: 20px;
}

.KeysHome .blog-details .meta-top i {
  font-size: 16px;
  margin-right: 8px;
  line-height: 0;
  color: color-mix(in srgb, var(--default-color), transparent 40%);
}

.KeysHome .blog-details .meta-top a {
  color: color-mix(in srgb, var(--default-color), transparent 40%);
  font-size: 14px;
  display: inline-block;
  line-height: 1;
}

.KeysHome .blog-details .meta-bottom {
  padding-top: 10px;
  border-top: 1px solid color-mix(in srgb, var(--default-color), transparent 90%);
}

.KeysHome .blog-details .meta-bottom i {
  color: color-mix(in srgb, var(--default-color), transparent 40%);
  display: inline;
}

.KeysHome .blog-details .meta-bottom a {
  color: color-mix(in srgb, var(--default-color), transparent 40%);
  transition: 0.3s;
}

.KeysHome .blog-details .meta-bottom a:hover {
  color: var(--accent-color);
}

.KeysHome .blog-details .meta-bottom .cats {
  list-style: none;
  display: inline;
  padding: 0 20px 0 0;
  font-size: 14px;
}

.KeysHome .blog-details .meta-bottom .cats li {
  display: inline-block;
}

.KeysHome .blog-details .meta-bottom .tags {
  list-style: none;
  display: inline;
  padding: 0;
  font-size: 14px;
}

.KeysHome .blog-details .meta-bottom .tags li {
  display: inline-block;
}

.KeysHome .blog-details .meta-bottom .tags li + li::before {
  padding-right: 6px;
  color: var(--default-color);
  content: ",";
}

.KeysHome .blog-details .meta-bottom .share {
  font-size: 16px;
}

.KeysHome .blog-details .meta-bottom .share i {
  padding-left: 5px;
}

/*--------------------------------------------------------------
# Blog Author Section
--------------------------------------------------------------*/
.KeysHome .blog-author {
  padding: 10px 0 40px 0;
}

.KeysHome .blog-author .author-container {
  background-color: var(--surface-color);
  padding: 20px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.KeysHome .blog-author img {
  max-width: 120px;
  margin-right: 20px;
}

.KeysHome .blog-author h4 {
  font-weight: 600;
  font-size: 20px;
  margin-bottom: 0px;
  padding: 0;
  color: color-mix(in srgb, var(--default-color), transparent 20%);
}

.KeysHome .blog-author .social-links {
  margin: 0 10px 10px 0;
}

.KeysHome .blog-author .social-links a {
  color: color-mix(in srgb, var(--default-color), transparent 60%);
  margin-right: 5px;
}

.KeysHome .blog-author p {
  font-style: italic;
  color: color-mix(in srgb, var(--default-color), transparent 30%);
  margin-bottom: 0;
}

/*--------------------------------------------------------------
# Blog Comments Section
--------------------------------------------------------------*/
.KeysHome .blog-comments {
  padding: 10px 0;
}

.KeysHome .blog-comments .comments-count {
  font-weight: bold;
}

.KeysHome .blog-comments .comment {
  margin-top: 30px;
  position: relative;
}

.KeysHome .blog-comments .comment .comment-img {
  margin-right: 14px;
}

.KeysHome .blog-comments .comment .comment-img img {
  width: 60px;
}

.KeysHome .blog-comments .comment h5 {
  font-size: 16px;
  margin-bottom: 2px;
}

.KeysHome .blog-comments .comment h5 a {
  font-weight: bold;
  color: var(--default-color);
  transition: 0.3s;
}

.KeysHome .blog-comments .comment h5 a:hover {
  color: var(--accent-color);
}

.KeysHome .blog-comments .comment h5 .reply {
  padding-left: 10px;
  color: color-mix(in srgb, var(--default-color), transparent 20%);
}

.KeysHome .blog-comments .comment h5 .reply i {
  font-size: 20px;
}

.KeysHome .blog-comments .comment time {
  display: block;
  font-size: 14px;
  color: color-mix(in srgb, var(--default-color), transparent 40%);
  margin-bottom: 5px;
}

.KeysHome .blog-comments .comment.comment-reply {
  padding-left: 40px;
}

/*--------------------------------------------------------------
# Comment Form Section
--------------------------------------------------------------*/
.KeysHome .comment-form {
  padding-top: 10px;
}

.KeysHome .comment-form form {
  background-color: var(--surface-color);
  margin-top: 30px;
  padding: 30px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.KeysHome .comment-form form h4 {
  font-weight: bold;
  font-size: 22px;
}

.KeysHome .comment-form form p {
  font-size: 14px;
}

.KeysHome .comment-form form input {
  background-color: var(--surface-color);
  color: var(--default-color);
  border: 1px solid color-mix(in srgb, var(--default-color), transparent 70%);
  font-size: 14px;
  border-radius: 4px;
  padding: 10px 10px;
}

.KeysHome .comment-form form input:focus {
  color: var(--default-color);
  background-color: var(--surface-color);
  box-shadow: none;
  border-color: var(--accent-color);
}

.KeysHome .comment-form form input::placeholder {
  color: color-mix(in srgb, var(--default-color), transparent 50%);
}

.KeysHome .comment-form form textarea {
  background-color: var(--surface-color);
  color: var(--default-color);
  border: 1px solid color-mix(in srgb, var(--default-color), transparent 70%);
  border-radius: 4px;
  padding: 10px 10px;
  font-size: 14px;
  height: 120px;
}

.KeysHome .comment-form form textarea:focus {
  color: var(--default-color);
  box-shadow: none;
  border-color: var(--accent-color);
  background-color: var(--surface-color);
}

.KeysHome .comment-form form textarea::placeholder {
  color: color-mix(in srgb, var(--default-color), transparent 50%);
}

.KeysHome .comment-form form .form-group {
  margin-bottom: 25px;
}

.KeysHome .comment-form form .btn-primary {
  border-radius: 4px;
  padding: 10px 20px;
  border: 0;
  background-color: var(--accent-color);
  color: var(--contrast-color);
}

.KeysHome .comment-form form .btn-primary:hover {
  color: var(--contrast-color);
  background-color: color-mix(in srgb, var(--accent-color), transparent 20%);
}

/*--------------------------------------------------------------
# Contact Section
--------------------------------------------------------------*/
.KeysHome .contact .info-item {
  background-color: var(--surface-color);
  padding: 20px 0 30px 0;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
}

.KeysHome .contact .info-item i {
  font-size: 20px;
  color: var(--accent-color);
  width: 56px;
  height: 56px;
  font-size: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  transition: all 0.3s ease-in-out;
  border-radius: 50%;
  border: 2px dotted color-mix(in srgb, var(--accent-color), transparent 40%);
}

.KeysHome .contact .info-item h3 {
  font-size: 20px;
  font-size: 18px;
  font-weight: 700;
  margin: 10px 0;
}

.KeysHome .contact .info-item p {
  padding: 0;
  margin-bottom: 0;
  font-size: 14px;
}

.KeysHome .contact .php-email-form {
  background-color: var(--surface-color);
  height: 100%;
  padding: 30px;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
}

@media (max-width: 575px) {
  .KeysHome .contact .php-email-form {
    padding: 20px;
  }
}

.KeysHome .contact .php-email-form input[type="text"],
.KeysHome .contact .php-email-form input[type="email"],
.KeysHome .contact .php-email-form textarea {
  font-size: 14px;
  padding: 10px 15px;
  box-shadow: none;
  border-radius: 0;
  color: var(--default-color);
  background-color: var(--surface-color);
  border-color: color-mix(in srgb, var(--default-color), transparent 80%);
}

.KeysHome .contact .php-email-form input[type="text"]:focus,
.KeysHome .contact .php-email-form input[type="email"]:focus,
.KeysHome .contact .php-email-form textarea:focus {
  border-color: var(--accent-color);
}

.KeysHome .contact .php-email-form input[type="text"]::placeholder,
.KeysHome .contact .php-email-form input[type="email"]::placeholder,
.KeysHome .contact .php-email-form textarea::placeholder {
  color: color-mix(in srgb, var(--default-color), transparent 70%);
}

.KeysHome .contact .php-email-form button[type="submit"] {
  color: var(--contrast-color);
  background: var(--accent-color);
  border: 0;
  padding: 10px 30px;
  transition: 0.4s;
  border-radius: 50px;
}

.KeysHome .contact .php-email-form button[type="submit"]:hover {
  background: color-mix(in srgb, var(--accent-color), transparent 20%);
}

/*--------------------------------------------------------------
# Starter Section Section
--------------------------------------------------------------*/
.KeysHome .starter-section {
  /* Add your styles here */
}

/*--------------------------------------------------------------
# Widgets
--------------------------------------------------------------*/
.KeysHome .widgets-container {
  background-color: var(--surface-color);
  padding: 30px;
  margin: 60px 0 30px 0;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.KeysHome .widget-title {
  color: var(--heading-color);
  font-size: 20px;
  font-weight: 700;
  padding: 0;
  margin: 0 0 20px 0;
}

.KeysHome .widget-item {
  margin-bottom: 40px;
}

.KeysHome .widget-item:last-child {
  margin-bottom: 0;
}

.KeysHome .search-widget form {
  background: var(--background-color);
  border: 1px solid color-mix(in srgb, var(--default-color), transparent 70%);
  padding: 3px 10px;
  position: relative;
  transition: 0.3s;
}

.KeysHome .search-widget form input[type="text"] {
  border: 0;
  padding: 4px;
  border-radius: 4px;
  width: calc(100% - 40px);
  background-color: var(--background-color);
  color: var(--default-color);
}

.KeysHome .search-widget form input[type="text"]:focus {
  outline: none;
}

.KeysHome .search-widget form button {
  background: var(--accent-color);
  color: var(--contrast-color);
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  border: 0;
  font-size: 16px;
  padding: 0 15px;
  margin: -1px;
  transition: 0.3s;
  border-radius: 0 4px 4px 0;
  line-height: 0;
}

.KeysHome .search-widget form button i {
  line-height: 0;
}

.KeysHome .search-widget form button:hover {
  background: color-mix(in srgb, var(--accent-color), transparent 20%);
}

.KeysHome .search-widget form:is(:focus-within) {
  border-color: var(--accent-color);
}

.KeysHome .categories-widget ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.KeysHome .categories-widget ul li {
  padding-bottom: 10px;
}

.KeysHome .categories-widget ul li:last-child {
  padding-bottom: 0;
}

.KeysHome .categories-widget ul a {
  color: color-mix(in srgb, var(--default-color), transparent 20%);
  transition: 0.3s;
}

.KeysHome .categories-widget ul a:hover {
  color: var(--accent-color);
}

.KeysHome .categories-widget ul a span {
  padding-left: 5px;
  color: color-mix(in srgb, var(--default-color), transparent 50%);
  font-size: 14px;
}

.KeysHome .recent-posts-widget .post-item {
  display: flex;
  margin-bottom: 15px;
}

.KeysHome .recent-posts-widget .post-item:last-child {
  margin-bottom: 0;
}

.KeysHome .recent-posts-widget .post-item img {
  width: 80px;
  margin-right: 15px;
}

.KeysHome .recent-posts-widget .post-item h4 {
  font-size: 15px;
  font-weight: bold;
  margin-bottom: 5px;
}

.KeysHome .recent-posts-widget .post-item h4 a {
  color: var(--default-color);
  transition: 0.3s;
}

.KeysHome .recent-posts-widget .post-item h4 a:hover {
  color: var(--accent-color);
}

.KeysHome .recent-posts-widget .post-item time {
  display: block;
  font-style: italic;
  font-size: 14px;
  color: color-mix(in srgb, var(--default-color), transparent 50%);
}

.KeysHome .tags-widget {
  margin-bottom: -10px;
}

.KeysHome .tags-widget ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.KeysHome .tags-widget ul li {
  display: inline-block;
}

.KeysHome .tags-widget ul a {
  color: color-mix(in srgb, var(--default-color), transparent 30%);
  font-size: 14px;
  padding: 6px 14px;
  margin: 0 6px 8px 0;
  border: 1px solid color-mix(in srgb, var(--default-color), transparent 60%);
  display: inline-block;
  transition: 0.3s;
}

.KeysHome .tags-widget ul a:hover {
  background: var(--accent-color);
  color: var(--contrast-color);
  border: 1px solid var(--accent-color);
}

.KeysHome .tags-widget ul a span {
  padding-left: 5px;
  color: color-mix(in srgb, var(--default-color), transparent 60%);
  font-size: 14px;
}
`, "",{"version":3,"sources":["webpack://./src/Key-Company/assets/css/main.css"],"names":[],"mappings":"AAAA;;;;;;CAMC;;AAED;;;+DAG+D;AAC/D,UAAU;AACV;EACE;;;sBAGoB;EACpB,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA,yJAAyJ;AACzJ;EACE,2BAA2B;EAC3B,2EAA2E;EAC3E,wBAAwB;EACxB,sFAAsF;EACtF,wBAAwB;EACxB,qEAAqE;EACrE,uBAAuB;EACvB,oIAAoI;EACpI,wBAAwB;EACxB,2LAA2L;EAC3L,yBAAyB;EACzB,6GAA6G;AAC/G;;AAEA,oLAAoL;AACpL;EACE,sCAAsC;EACtC,gDAAgD;EAChD,0BAA0B;EAC1B,uEAAuE;EACvE,sCAAsC;EACtC,4DAA4D;EAC5D,wCAAwC;EACxC,4GAA4G;EAC5G,6BAA6B;EAC7B,4EAA4E;EAC5E,mCAAmC;EACnC,iHAAiH;AACnH;;AAEA,0IAA0I;;AAE1I;EACE,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,uBAAuB;AACzB;;AAEA;;+DAE+D;AAC/D;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,+DAA+D;EAC/D,qBAAqB;AACvB;;AAEA;;;;;;EAME,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;+BAC+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,qCAAqC;EACrC,sCAAsC;EACtC,oDAAoD;AACtD;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;;+DAE+D;AAC/D;EACE,0CAA0C;EAC1C,wBAAwB;EACxB,wBAAwB;EACxB,2BAA2B;EAC3B,yCAAyC;EACzC,eAAe;EACf,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;+BAC+B;AAC/B;EACE,6CAA6C;EAC7C,wBAAwB;EACxB,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;;+DAE+D;AAC/D,uBAAuB;AACvB;EACE;IACE,UAAU;EACZ;;EAEA;IACE,SAAS;IACT,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,uBAAuB;IACvB,eAAe;IACf,cAAc;IACd,4BAA4B;IAC5B,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;;IAEE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,OAAO;IACP,qCAAqC;IACrC,kBAAkB;IAClB,UAAU;IACV,mCAAmC;EACrC;;EAEA;;;IAGE,mBAAmB;IACnB,WAAW;EACb;;EAEA;;;IAGE,6BAA6B;EAC/B;;EAEA;IACE,SAAS;IACT,eAAe;IACf,gDAAgD;IAChD,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,2CAA2C;EAC7C;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,gBAAgB;IAChB,gCAAgC;EAClC;;EAEA;IACE,eAAe;EACjB;;EAEA;;;IAGE,sCAAsC;EACxC;;EAEA;IACE,UAAU;IACV,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,MAAM;IACN,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,MAAM;IACN,WAAW;IACX,mBAAmB;EACrB;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,uBAAuB;IACvB,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,0BAA0B;IAC1B,eAAe;IACf,SAAS;IACT,kBAAkB;IAClB,oDAAoD;IACpD,2EAA2E;IAC3E,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;EACf;;EAEA;;IAEE,gCAAgC;IAChC,kBAAkB;IAClB,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;;IAEE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,0EAA0E;EAC5E;;EAEA;;IAEE,qCAAqC;IACrC,4BAA4B;EAC9B;;EAEA;;;IAGE,sCAAsC;EACxC;;EAEA;;IAEE,qCAAqC;IACrC,4BAA4B;IAC5B,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,sDAAsD;IACtD,gCAAgC;EAClC;;EAEA;IACE,uCAAuC;EACzC;;EAEA;IACE,cAAc;IACd,wCAAwC;EAC1C;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,SAAS;IACT,WAAW;IACX,eAAe;IACf,aAAa;EACf;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,QAAQ;IACR,iCAAiC;IACjC,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;;+DAE+D;AAC/D;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,wEAA4D;EAC5D,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,wEAAwE;EACxE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2EAA2E;EAC3E,eAAe;EACf,gEAAgE;EAChE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gEAAgE;EAChE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,+EAA+E;AACjF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;;+DAE+D;AAC/D;EACE,eAAe;EACf,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,6EAA6E;EAC7E,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iDAAiD;AACnD;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;;+DAE+D;AAC/D;EACE,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,cAAc;EACd,qCAAqC;EACrC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,0EAA0E;EAC1E,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;;+DAE+D;AAC/D;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;;+DAE+D;AAC/D;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,8EAA8E;EAC9E,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,UAAU;EACV,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,gEAAgE;AAClE;;AAEA;;+DAE+D;AAC/D;;EAEE,sCAAsC;EACtC,oDAAoD;EACpD,eAAe;EACf,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE;;IAEE,uBAAuB;EACzB;AACF;;AAEA;;+DAE+D;AAC/D;EACE,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,WAAW;EACX,WAAW;EACX,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;+DAE+D;AAC/D;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,wCAAwC;EACxC,yCAAyC;EACzC,2BAA2B;EAC3B,kCAAkC;EAClC,0BAA0B;EAC1B,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,WAAW;EACX,+BAA+B;EAC/B,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;AACd;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,8EAA8E;EAC9E,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,qEAAqE;EACrE,gEAAgE;EAChE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,UAAU;EACV,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;;+DAE+D;AAC/D;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,WAAW;EACX,+BAA+B;EAC/B,OAAO;EACP,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qEAAqE;EACrE,aAAa;EACb,YAAY;AACd;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;;;EAGE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;EAC3B,8EAA8E;EAC9E,uEAAuE;AACzE;;AAEA;;;EAGE,iCAAiC;AACnC;;AAEA;;;EAGE,gEAAgE;AAClE;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oEAAoE;AACtE;;AAEA;;+DAE+D;AAC/D;EACE,sCAAsC;EACtC,2EAA2E;EAC3E,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gEAAgE;EAChE,SAAS;AACX;;AAEA;;+DAE+D;AAC/D;EACE,sCAAsC;EACtC,aAAa;EACb,yCAAyC;EACzC,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,4BAA4B;EAC5B,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,qEAAqE;EACrE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gEAAgE;EAChE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,kFAAkF;EAClF,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,gEAAgE;AAClE;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;+DAE+D;AAC/D;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,WAAW;EACX,OAAO;EACP,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;+DAE+D;AAC/D;EACE,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,SAAS;EACT,kFAAkF;AACpF;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,0BAA0B;EAC1B,uEAAuE;AACzE;;AAEA;EACE,yCAAyC;EACzC,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,WAAW;EACX,+BAA+B;EAC/B,OAAO;EACP,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;+DAE+D;AAC/D;EACE,UAAU;EACV,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;IACf,aAAa;EACf;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,gCAAgC;EAChC,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;;EAEE,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;+DAE+D;AAC/D;EACE,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,2CAA2C;EAC3C,uBAAuB;EACvB,4BAA4B;EAC5B,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gEAAgE;EAChE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;;EAEE,+DAA+D;EAC/D,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,UAAU;EACV,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,UAAU;EACZ;AACF;;AAEA;;+DAE+D;AAC/D;EACE,gCAAgC;EAChC,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,qCAAqC;EACrC,4BAA4B;EAC5B,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gEAAgE;AAClE;;AAEA;EACE,gEAAgE;EAChE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gEAAgE;AAClE;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;+DAE+D;AAC/D;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,cAAc;IACd,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;EACb,2EAA2E;AAC7E;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,gEAAgE;AAClE;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gEAAgE;AAClE;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,gEAAgE;EAChE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE;IACE,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,iBAAiB;EACnB;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;;+DAE+D;AAC/D;EACE,yCAAyC;EACzC,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,gCAAgC;EAChC,eAAe;AACjB;;AAEA;;+DAE+D;AAC/D;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;+DAE+D;AAC/D;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,aAAa;AACf;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gEAAgE;EAChE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;;+DAE+D;AAC/D;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gEAAgE;AAClE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,gEAAgE;AAClE;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;;+DAE+D;AAC/D;EACE,sCAAsC;EACtC,kBAAkB;EAClB,2EAA2E;EAC3E,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,uBAAuB;EACvB,gFAAgF;EAChF,cAAc;EACd,gEAAgE;EAChE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;;+DAE+D;AAC/D;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,+BAA+B;EAC/B,qCAAqC;EACrC,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE;;IAEE,aAAa;EACf;AACF;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2EAA2E;EAC3E,UAAU;AACZ;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,WAAW;EACX,+BAA+B;EAC/B,OAAO;EACP,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,gEAAgE;EAChE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oEAAoE;AACtE;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,qEAAqE;EACrE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,yCAAyC;EACzC,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;;EAEE,+DAA+D;EAC/D,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,UAAU;AACZ;;AAEA;;+DAE+D;AAC/D;EACE,sCAAsC;EACtC,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,4BAA4B;EAC5B,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gEAAgE;AAClE;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gEAAgE;EAChE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gEAAgE;AAClE;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;+DAE+D;AAC/D;EACE,cAAc;EACd,gEAAgE;AAClE;;AAEA;EACE,aAAa;EACb,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gEAAgE;EAChE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;+DAE+D;AAC/D;EACE,oBAAoB;AACtB;;AAEA;EACE,sCAAsC;EACtC,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,2EAA2E;EAC3E,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,UAAU;EACV,qCAAqC;EACrC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gEAAgE;AAClE;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gEAAgE;AAClE;;AAEA;EACE,gEAAgE;EAChE,eAAe;EACf,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,+EAA+E;AACjF;;AAEA;EACE,gEAAgE;EAChE,eAAe;AACjB;;AAEA;EACE,gEAAgE;EAChE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;+DAE+D;AAC/D;EACE,sBAAsB;AACxB;;AAEA;EACE,sCAAsC;EACtC,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,gEAAgE;AAClE;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gEAAgE;EAChE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gEAAgE;EAChE,gBAAgB;AAClB;;AAEA;;+DAE+D;AAC/D;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,gEAAgE;AAClE;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gEAAgE;EAChE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;+DAE+D;AAC/D;EACE,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,2BAA2B;EAC3B,2EAA2E;EAC3E,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;EACtC,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EACE,sCAAsC;EACtC,2BAA2B;EAC3B,2EAA2E;EAC3E,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,iCAAiC;EACjC,sCAAsC;AACxC;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,0EAA0E;AAC5E;;AAEA;;+DAE+D;AAC/D;EACE,sCAAsC;EACtC,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;EAClB,2EAA2E;AAC7E;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,aAAa;EACb,2CAA2C;AAC7C;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;;;EAGE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;EAC3B,sCAAsC;EACtC,uEAAuE;AACzE;;AAEA;;;EAGE,iCAAiC;AACnC;;AAEA;;;EAGE,gEAAgE;AAClE;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oEAAoE;AACtE;;AAEA;;+DAE+D;AAC/D;EACE,yBAAyB;AAC3B;;AAEA;;+DAE+D;AAC/D;EACE,sCAAsC;EACtC,aAAa;EACb,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,2EAA2E;EAC3E,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,SAAS;EACT,eAAe;EACf,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oEAAoE;AACtE;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gEAAgE;EAChE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,gEAAgE;EAChE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gEAAgE;AAClE;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gEAAgE;EAChE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,2EAA2E;EAC3E,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,gEAAgE;EAChE,eAAe;AACjB","sourcesContent":["/**\n* Template Name: UpConstruction\n* Template URL: https://bootstrapmade.com/upconstruction-bootstrap-construction-website-template/\n* Updated: Aug 07 2024 with Bootstrap v5.3.3\n* Author: BootstrapMade.com\n* License: https://bootstrapmade.com/license/\n*/\n\n/*--------------------------------------------------------------\n# Font & Color Variables\n# Help: https://bootstrapmade.com/color-system/\n--------------------------------------------------------------*/\n/* Fonts */\n.KeysHome {\n  --default-font:\n    \"Open Sans\", system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\",\n    \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\",\n    \"Noto Color Emoji\";\n  --heading-font: \"Roboto\", sans-serif;\n  --nav-font: \"Poppins\", sans-serif;\n}\n\n/* Global Colors - The following color variables are used throughout the website. Updating them here will change the color scheme of the entire website */\n.KeysHome {\n  --background-color: #ffffff;\n  /* Background color for the entire website, including individual sections */\n  --default-color: #364d59;\n  /* Default color used for the majority of the text content across the entire website */\n  --heading-color: #52565e;\n  /* Color for headings, subheadings and title throughout the website */\n  --accent-color: #feb900;\n  /* Accent color that represents your brand on the website. It's used for buttons, links, and other elements that need to stand out */\n  --surface-color: #ffffff;\n  /* The surface color is used as a background of boxed elements within sections, such as cards, icon boxes, or other elements that require a visual separation from the global background. */\n  --contrast-color: #ffffff;\n  /* Contrast color for text, ensuring readability against backgrounds of accent, heading, or default colors. */\n}\n\n/* Nav Menu Colors - The following color variables are used specifically for the navigation menu. They are separate from the global colors to allow for more customization options */\n.KeysHome {\n  --nav-color: rgba(255, 255, 255, 0.55);\n  /* The default color of the main navmenu links */\n  --nav-hover-color: #ffffff;\n  /* Applied to main navmenu links when they are hovered over or active */\n  --nav-mobile-background-color: #ffffff;\n  /* Used as the background color for mobile navigation menu */\n  --nav-dropdown-background-color: #ffffff;\n  /* Used as the background color for dropdown items that appear when hovering over primary navigation items */\n  --nav-dropdown-color: #212529;\n  /* Used for navigation links of the dropdown items in the navigation menu. */\n  --nav-dropdown-hover-color: #feb900;\n  /* Similar to --nav-hover-color, this color is applied to dropdown navigation links when they are hovered over. */\n}\n\n/* Color Presets - These classes override global colors when applied to any section or element, providing reuse of the sam color scheme. */\n\n.KeysHome .light-background {\n  --background-color: #f4f7f6;\n  --surface-color: #ffffff;\n}\n\n.KeysHome .dark-background {\n  --background-color: #060606;\n  --default-color: #ffffff;\n  --heading-color: #ffffff;\n  --surface-color: #252525;\n  --contrast-color: #ffffff;\n}\n\n/* Smooth scroll */\n.KeysHome {\n  scroll-behavior: smooth;\n}\n\n/*--------------------------------------------------------------\n# General Styling & Shared Classes\n--------------------------------------------------------------*/\n.KeysHome {\n  color: var(--default-color);\n  background-color: var(--background-color);\n  font-family: var(--default-font);\n}\n\n.KeysHome a {\n  color: var(--accent-color);\n  text-decoration: none;\n  transition: 0.3s;\n}\n\n.KeysHome a:hover {\n  color: color-mix(in srgb, var(--accent-color), transparent 25%);\n  text-decoration: none;\n}\n\n.KeysHome h1,\n.KeysHome h2,\n.KeysHome h3,\n.KeysHome h4,\n.KeysHome h5,\n.KeysHome h6 {\n  color: var(--heading-color);\n  font-family: var(--heading-font);\n}\n\n/* PHP Email Form Messages\n------------------------------*/\n.KeysHome .php-email-form .error-message {\n  display: none;\n  background: #df1529;\n  color: #ffffff;\n  text-align: left;\n  padding: 15px;\n  margin-bottom: 24px;\n  font-weight: 600;\n}\n\n.KeysHome .php-email-form .sent-message {\n  display: none;\n  color: #ffffff;\n  background: #059652;\n  text-align: center;\n  padding: 15px;\n  margin-bottom: 24px;\n  font-weight: 600;\n}\n\n.KeysHome .php-email-form .loading {\n  display: none;\n  background: var(--surface-color);\n  text-align: center;\n  padding: 15px;\n  margin-bottom: 24px;\n}\n\n.KeysHome .php-email-form .loading:before {\n  content: \"\";\n  display: inline-block;\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  margin: 0 10px -6px 0;\n  border: 3px solid var(--accent-color);\n  border-top-color: var(--surface-color);\n  animation: php-email-form-loading 1s linear infinite;\n}\n\n@keyframes php-email-form-loading {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/*--------------------------------------------------------------\n# Global Header\n--------------------------------------------------------------*/\n.KeysHome .header {\n  --background-color: rgba(255, 255, 255, 0);\n  --default-color: #ffffff;\n  --heading-color: #ffffff;\n  color: var(--default-color);\n  background-color: var(--background-color);\n  padding: 20px 0;\n  transition: all 0.5s;\n  z-index: 997;\n}\n\n.KeysHome .header .logo img {\n  max-height: 32px;\n  margin-right: 8px;\n}\n\n.KeysHome .header .logo h1 {\n  font-size: 24px;\n  margin: 0;\n  font-weight: 700;\n  color: var(--heading-color);\n}\n\n.KeysHome .header .logo span {\n  font-size: 24px;\n  padding-left: 1px;\n  font-family: var(--heading-font);\n  color: var(--color-primary);\n}\n\n.KeysHome .scrolled .header {\n  box-shadow: 0px 0 18px rgba(0, 0, 0, 0.1);\n}\n\n/* Global Header on Scroll\n------------------------------*/\n.KeysHome .scrolled .header {\n  --background-color: rgba(255, 255, 255, 0.95);\n  --heading-color: #3c3c3c;\n  --nav-color: #3c3c3c;\n  --nav-hover-color: #3c3c3c;\n}\n\n/*--------------------------------------------------------------\n# Navigation Menu\n--------------------------------------------------------------*/\n/* Desktop Navigation */\n@media (min-width: 1200px) {\n  .KeysHome .navmenu {\n    padding: 0;\n  }\n\n  .KeysHome .navmenu ul {\n    margin: 0;\n    padding: 0;\n    display: flex;\n    list-style: none;\n    align-items: center;\n  }\n\n  .KeysHome .navmenu li {\n    position: relative;\n  }\n\n  .KeysHome .navmenu > ul > li {\n    white-space: nowrap;\n    padding: 15px 14px;\n  }\n\n  .KeysHome .navmenu > ul > li:last-child {\n    padding-right: 0;\n  }\n\n  .KeysHome .navmenu a,\n  .KeysHome .navmenu a:focus {\n    color: var(--nav-color);\n    font-size: 14px;\n    padding: 0 2px;\n    font-family: var(--nav-font);\n    font-weight: 500;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    white-space: nowrap;\n    transition: 0.3s;\n    position: relative;\n    text-transform: uppercase;\n  }\n\n  .KeysHome .navmenu a i,\n  .KeysHome .navmenu a:focus i {\n    font-size: 12px;\n    line-height: 0;\n    margin-left: 5px;\n    transition: 0.3s;\n  }\n\n  .KeysHome .navmenu > ul > li > a:before {\n    content: \"\";\n    position: absolute;\n    height: 2px;\n    bottom: -6px;\n    left: 0;\n    background-color: var(--accent-color);\n    visibility: hidden;\n    width: 0px;\n    transition: all 0.3s ease-in-out 0s;\n  }\n\n  .KeysHome .navmenu a:hover:before,\n  .KeysHome .navmenu li:hover > a:before,\n  .KeysHome .navmenu .active:before {\n    visibility: visible;\n    width: 100%;\n  }\n\n  .KeysHome .navmenu li:hover > a,\n  .KeysHome .navmenu .active,\n  .KeysHome .navmenu .active:focus {\n    color: var(--nav-hover-color);\n  }\n\n  .KeysHome .navmenu .dropdown ul {\n    margin: 0;\n    padding: 10px 0;\n    background: var(--nav-dropdown-background-color);\n    display: block;\n    position: absolute;\n    visibility: hidden;\n    left: 14px;\n    top: 130%;\n    opacity: 0;\n    transition: 0.3s;\n    border-radius: 4px;\n    z-index: 99;\n    box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1);\n  }\n\n  .KeysHome .navmenu .dropdown ul li {\n    min-width: 200px;\n  }\n\n  .KeysHome .navmenu .dropdown ul a {\n    padding: 10px 20px;\n    font-size: 15px;\n    text-transform: none;\n    font-weight: 400;\n    color: var(--nav-dropdown-color);\n  }\n\n  .KeysHome .navmenu .dropdown ul a i {\n    font-size: 12px;\n  }\n\n  .KeysHome .navmenu .dropdown ul a:hover,\n  .KeysHome .navmenu .dropdown ul .active:hover,\n  .KeysHome .navmenu .dropdown ul li:hover > a {\n    color: var(--nav-dropdown-hover-color);\n  }\n\n  .KeysHome .navmenu .dropdown:hover > ul {\n    opacity: 1;\n    top: 100%;\n    visibility: visible;\n  }\n\n  .KeysHome .navmenu .dropdown .dropdown ul {\n    top: 0;\n    left: -90%;\n    visibility: hidden;\n  }\n\n  .KeysHome .navmenu .dropdown .dropdown:hover > ul {\n    opacity: 1;\n    top: 0;\n    left: -100%;\n    visibility: visible;\n  }\n}\n\n/* Mobile Navigation */\n@media (max-width: 1199px) {\n  .KeysHome .mobile-nav-toggle {\n    color: var(--nav-color);\n    font-size: 28px;\n    line-height: 0;\n    margin-right: 10px;\n    cursor: pointer;\n    transition: color 0.3s;\n  }\n\n  .KeysHome .navmenu {\n    padding: 0;\n    z-index: 9997;\n  }\n\n  .KeysHome .navmenu ul {\n    display: none;\n    list-style: none;\n    position: absolute;\n    inset: 60px 20px 20px 20px;\n    padding: 10px 0;\n    margin: 0;\n    border-radius: 6px;\n    background-color: var(--nav-mobile-background-color);\n    border: 1px solid color-mix(in srgb, var(--default-color), transparent 90%);\n    box-shadow: none;\n    overflow-y: auto;\n    transition: 0.3s;\n    z-index: 9998;\n  }\n\n  .KeysHome .navmenu a,\n  .KeysHome .navmenu a:focus {\n    color: var(--nav-dropdown-color);\n    padding: 10px 20px;\n    font-family: var(--nav-font);\n    font-size: 17px;\n    font-weight: 500;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    white-space: nowrap;\n    transition: 0.3s;\n  }\n\n  .KeysHome .navmenu a i,\n  .KeysHome .navmenu a:focus i {\n    font-size: 12px;\n    line-height: 0;\n    margin-left: 5px;\n    width: 30px;\n    height: 30px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    transition: 0.3s;\n    background-color: color-mix(in srgb, var(--accent-color), transparent 90%);\n  }\n\n  .KeysHome .navmenu a i:hover,\n  .KeysHome .navmenu a:focus i:hover {\n    background-color: var(--accent-color);\n    color: var(--contrast-color);\n  }\n\n  .KeysHome .navmenu a:hover,\n  .KeysHome .navmenu .active,\n  .KeysHome .navmenu .active:focus {\n    color: var(--nav-dropdown-hover-color);\n  }\n\n  .KeysHome .navmenu .active i,\n  .KeysHome .navmenu .active:focus i {\n    background-color: var(--accent-color);\n    color: var(--contrast-color);\n    transform: rotate(180deg);\n  }\n\n  .KeysHome .navmenu .dropdown ul {\n    position: static;\n    display: none;\n    z-index: 99;\n    padding: 10px 0;\n    margin: 10px 20px;\n    background-color: var(--nav-dropdown-background-color);\n    transition: all 0.5s ease-in-out;\n  }\n\n  .KeysHome .navmenu .dropdown ul ul {\n    background-color: rgba(33, 37, 41, 0.1);\n  }\n\n  .KeysHome .navmenu .dropdown > .dropdown-active {\n    display: block;\n    background-color: rgba(33, 37, 41, 0.03);\n  }\n\n  .KeysHome .mobile-nav-active {\n    overflow: hidden;\n  }\n\n  .KeysHome .mobile-nav-active .mobile-nav-toggle {\n    color: #fff;\n    position: absolute;\n    font-size: 32px;\n    top: 15px;\n    right: 15px;\n    margin-right: 0;\n    z-index: 9999;\n  }\n\n  .KeysHome .mobile-nav-active .navmenu {\n    position: fixed;\n    overflow: hidden;\n    inset: 0;\n    background: rgba(33, 37, 41, 0.8);\n    transition: 0.3s;\n  }\n\n  .KeysHome .mobile-nav-active .navmenu > ul {\n    display: block;\n  }\n}\n\n/*--------------------------------------------------------------\n# Global Footer\n--------------------------------------------------------------*/\n.KeysHome .footer {\n  color: var(--default-color);\n  background-color: var(--background-color);\n  background: url(\"../img/footer-bg.jpg\") top center no-repeat;\n  background-size: cover;\n  font-size: 14px;\n  position: relative;\n}\n\n.KeysHome .footer .container {\n  position: relative;\n}\n\n.KeysHome .footer:before {\n  content: \"\";\n  background: color-mix(in srgb, var(--background-color), transparent 20%);\n  position: absolute;\n  inset: 0;\n}\n\n.KeysHome .footer .footer-top {\n  padding-top: 50px;\n}\n\n.KeysHome .footer .footer-about .logo {\n  line-height: 1;\n  margin-bottom: 25px;\n}\n\n.KeysHome .footer .footer-about .logo img {\n  max-height: 40px;\n  margin-right: 6px;\n}\n\n.KeysHome .footer .footer-about .logo span {\n  color: var(--heading-color);\n  font-family: var(--heading-font);\n  font-size: 26px;\n  font-weight: 700;\n  letter-spacing: 1px;\n}\n\n.KeysHome .footer .footer-about p {\n  font-size: 14px;\n  font-family: var(--heading-font);\n}\n\n.KeysHome .footer .social-links a {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 5px;\n  border: 1px solid color-mix(in srgb, var(--default-color), transparent 50%);\n  font-size: 16px;\n  color: color-mix(in srgb, var(--default-color), transparent 20%);\n  margin-right: 10px;\n  transition: 0.3s;\n}\n\n.KeysHome .footer .social-links a:hover {\n  color: var(--accent-color);\n  border-color: var(--accent-color);\n}\n\n.KeysHome .footer h4 {\n  font-size: 16px;\n  font-weight: bold;\n  position: relative;\n  padding-bottom: 12px;\n}\n\n.KeysHome .footer .footer-links {\n  margin-bottom: 30px;\n}\n\n.KeysHome .footer .footer-links ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.KeysHome .footer .footer-links ul i {\n  padding-right: 2px;\n  font-size: 12px;\n  line-height: 0;\n}\n\n.KeysHome .footer .footer-links ul li {\n  padding: 10px 0;\n  display: flex;\n  align-items: center;\n}\n\n.KeysHome .footer .footer-links ul li:first-child {\n  padding-top: 0;\n}\n\n.KeysHome .footer .footer-links ul a {\n  color: color-mix(in srgb, var(--default-color), transparent 30%);\n  display: inline-block;\n  line-height: 1;\n}\n\n.KeysHome .footer .footer-links ul a:hover {\n  color: var(--accent-color);\n}\n\n.KeysHome .footer .footer-contact p {\n  margin-bottom: 5px;\n}\n\n.KeysHome .footer .copyright {\n  padding-top: 25px;\n  padding-bottom: 25px;\n  border-top: 1px solid color-mix(in srgb, var(--default-color), transparent 90%);\n}\n\n.KeysHome .footer .copyright p {\n  margin-bottom: 0;\n}\n\n.KeysHome .footer .credits {\n  margin-top: 8px;\n  font-size: 13px;\n}\n\n/*--------------------------------------------------------------\n# Preloader\n--------------------------------------------------------------*/\n.KeysHome #preloader {\n  position: fixed;\n  inset: 0;\n  z-index: 999999;\n  overflow: hidden;\n  background: var(--background-color);\n  transition: all 0.6s ease-out;\n}\n\n.KeysHome #preloader:before {\n  content: \"\";\n  position: fixed;\n  top: calc(50% - 30px);\n  left: calc(50% - 30px);\n  border: 6px solid #ffffff;\n  border-color: var(--accent-color) transparent var(--accent-color) transparent;\n  border-radius: 50%;\n  width: 60px;\n  height: 60px;\n  animation: animate-preloader 1.5s linear infinite;\n}\n\n@keyframes animate-preloader {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/*--------------------------------------------------------------\n# Scroll Top Button\n--------------------------------------------------------------*/\n.KeysHome .scroll-top {\n  position: fixed;\n  visibility: hidden;\n  opacity: 0;\n  right: 15px;\n  bottom: 15px;\n  z-index: 99999;\n  background-color: var(--accent-color);\n  width: 40px;\n  height: 40px;\n  border-radius: 4px;\n  transition: all 0.4s;\n}\n\n.KeysHome .scroll-top i {\n  font-size: 24px;\n  color: var(--default-color);\n  line-height: 0;\n}\n\n.KeysHome .scroll-top:hover {\n  background-color: color-mix(in srgb, var(--accent-color), transparent 20%);\n  color: var(--contrast-color);\n}\n\n.KeysHome .scroll-top.active {\n  visibility: visible;\n  opacity: 1;\n}\n\n/*--------------------------------------------------------------\n# Disable aos animation delay on mobile devices\n--------------------------------------------------------------*/\n@media screen and (max-width: 768px) {\n  .KeysHome [data-aos-delay] {\n    transition-delay: 0 !important;\n  }\n}\n\n/*--------------------------------------------------------------\n# Global Page Titles & Breadcrumbs\n--------------------------------------------------------------*/\n.KeysHome .page-title {\n  color: var(--default-color);\n  background-color: var(--background-color);\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  padding: 160px 0 60px 0;\n  text-align: center;\n  position: relative;\n}\n\n.KeysHome .page-title:before {\n  content: \"\";\n  background-color: color-mix(in srgb, var(--background-color), transparent 40%);\n  position: absolute;\n  inset: 0;\n}\n\n.KeysHome .page-title h1 {\n  font-size: 56px;\n  font-weight: 500;\n  margin-bottom: 10px;\n}\n\n.KeysHome .page-title .breadcrumbs ol {\n  display: flex;\n  flex-wrap: wrap;\n  list-style: none;\n  justify-content: center;\n  padding: 0;\n  margin: 0;\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.KeysHome .page-title .breadcrumbs ol li + li {\n  padding-left: 10px;\n}\n\n.KeysHome .page-title .breadcrumbs ol li + li::before {\n  content: \"/\";\n  display: inline-block;\n  padding-right: 10px;\n  color: color-mix(in srgb, var(--default-color), transparent 20%);\n}\n\n/*--------------------------------------------------------------\n# Global Sections\n--------------------------------------------------------------*/\n.KeysHome section,\n.KeysHome .section {\n  color: var(--default-color) !important;\n  background-color: var(--background-color) !important;\n  padding: 60px 0;\n  scroll-margin-top: 92px;\n  overflow: clip;\n}\n\n@media (max-width: 1199px) {\n  .KeysHome section,\n  .KeysHome .section {\n    scroll-margin-top: 76px;\n  }\n}\n\n/*--------------------------------------------------------------\n# Global Section Titles\n--------------------------------------------------------------*/\n.KeysHome .section-title {\n  text-align: center;\n  padding-bottom: 60px;\n  position: relative;\n}\n\n.KeysHome .section-title h2 {\n  font-size: 32px;\n  font-weight: 700;\n  position: relative;\n}\n\n.KeysHome .section-title h2:before,\n.KeysHome .section-title h2:after {\n  content: \"\";\n  width: 50px;\n  height: 2px;\n  background: var(--accent-color);\n  display: inline-block;\n}\n\n.KeysHome .section-title h2:before {\n  margin: 0 15px 10px 0;\n}\n\n.KeysHome .section-title h2:after {\n  margin: 0 0 10px 15px;\n}\n\n.KeysHome .section-title p {\n  margin-bottom: 0;\n}\n\n/*--------------------------------------------------------------\n# Hero Section\n--------------------------------------------------------------*/\n.KeysHome .hero {\n  width: 100%;\n  min-height: 100vh;\n  position: relative;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  background-color: rgba(0, 0, 0, 0.6);\n}\n\n.KeysHome .header {\n  padding: 10px 0px !important;\n}\n\n.KeysHome .header.sticked {\n  /* background-color: white !important; */\n  box-shadow: 0px 0 18px rgba(0, 0, 0, 0.4);\n  color: var(--default-color);\n  background-color: white !important;\n  padding: 40px 0 !important;\n  transition: all 0.5s;\n  z-index: 997 !important;\n}\n\n.KeysHome .header.sticked a,\n.KeysHome .header.sticked h1 {\n  color: black !important;\n}\n\n.KeysHome .hero .info {\n  position: relative;\n  inset: 0;\n  z-index: 3;\n  padding: 140px 0 60px 0;\n}\n\n@media (max-width: 768px), (max-height: 480px) {\n  .KeysHome .hero .info {\n    padding: 100px 50px 60px 50px;\n  }\n}\n\n.KeysHome .hero .info h2 {\n  margin-bottom: 30px;\n  color: white !important;\n  padding-bottom: 30px;\n  font-size: 56px;\n  font-weight: 700;\n  position: relative;\n}\n\n.KeysHome .hero .info h2:after {\n  content: \"\";\n  position: absolute;\n  display: block;\n  width: 80px;\n  height: 4px;\n  background: var(--accent-color);\n  left: 0;\n  right: 0;\n  bottom: 0;\n  margin: auto;\n}\n\n@media (max-width: 768px) {\n  .KeysHome .hero .info h2 {\n    font-size: 36px;\n  }\n}\n\n.KeysHome .hero .info p {\n  color: rgb(211, 208, 208);\n  font-size: 18px;\n}\n\n.KeysHome .hero .info .btn-get-started {\n  color: var(--contrast-color);\n  font-family: var(--heading-font);\n  font-weight: 500;\n  font-size: 16px;\n  letter-spacing: 1px;\n  display: inline-block;\n  padding: 12px 40px;\n  border-radius: 50px;\n  transition: 0.5s;\n  margin: 10px;\n  border: 2px solid var(--accent-color);\n}\n\n.KeysHome .hero .info .btn-get-started:hover {\n  background: var(--accent-color);\n}\n\n.KeysHome .hero .swiper {\n  inset: 0;\n  position: absolute;\n  overflow: hidden;\n  width: 100%;\n  height: 100%;\n  z-index: -1;\n}\n\n.KeysHome .hero .carousel-item {\n  position: absolute;\n  inset: 0;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  overflow: hidden;\n  transition-duration: 0.4s;\n}\n\n.KeysHome .hero .carousel-item img {\n  position: absolute;\n  inset: 0;\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  z-index: 1;\n}\n\n.KeysHome .hero .carousel-item::before {\n  content: \"\";\n  background-color: color-mix(in srgb, var(--background-color), transparent 30%);\n  position: absolute;\n  inset: 0;\n  z-index: 2;\n}\n\n.KeysHome .hero .carousel-control-prev {\n  justify-content: start;\n}\n\n@media (min-width: 640px) {\n  .KeysHome .hero .carousel-control-prev {\n    padding-left: 15px;\n  }\n}\n\n.KeysHome .hero .carousel-control-next {\n  justify-content: end;\n}\n\n@media (min-width: 640px) {\n  .KeysHome .hero .carousel-control-next {\n    padding-right: 15px;\n  }\n}\n\n.KeysHome .hero .carousel-control-next-icon,\n.KeysHome .hero .carousel-control-prev-icon {\n  background: none;\n  font-size: 26px;\n  line-height: 0;\n  background: color-mix(in srgb, var(--default-color), transparent 80%);\n  color: color-mix(in srgb, var(--default-color), transparent 40%);\n  border-radius: 50px;\n  width: 54px;\n  height: 54px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.KeysHome .hero .carousel-control-prev,\n.KeysHome .hero .carousel-control-next {\n  z-index: 3;\n  transition: 0.3s;\n}\n\n.KeysHome .hero .carousel-control-prev:focus,\n.KeysHome .hero .carousel-control-next:focus {\n  opacity: 0.5;\n}\n\n.KeysHome .hero .carousel-control-prev:hover,\n.KeysHome .hero .carousel-control-next:hover {\n  opacity: 0.9;\n}\n\n/*--------------------------------------------------------------\n# Get Started Section\n--------------------------------------------------------------*/\n.KeysHome .get-started .content {\n  padding: 30px 0;\n}\n\n.KeysHome .get-started .content h3 {\n  font-size: 36px;\n  font-weight: 600;\n  margin-bottom: 25px;\n  padding-bottom: 25px;\n  position: relative;\n}\n\n.KeysHome .get-started .content h3:after {\n  content: \"\";\n  position: absolute;\n  display: block;\n  width: 60px;\n  height: 4px;\n  background: var(--accent-color);\n  left: 0;\n  bottom: 0;\n}\n\n.KeysHome .get-started .content p {\n  font-size: 14px;\n}\n\n.KeysHome .get-started .php-email-form {\n  background: color-mix(in srgb, var(--default-color), transparent 97%);\n  padding: 30px;\n  height: 100%;\n}\n\n@media (max-width: 575px) {\n  .KeysHome .get-started .php-email-form {\n    padding: 20px;\n  }\n}\n\n.KeysHome .get-started .php-email-form h3 {\n  font-size: 14px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.KeysHome .get-started .php-email-form p {\n  font-size: 14px;\n  margin-bottom: 20px;\n}\n\n.KeysHome .get-started .php-email-form input[type=\"text\"],\n.KeysHome .get-started .php-email-form input[type=\"email\"],\n.KeysHome .get-started .php-email-form textarea {\n  font-size: 14px;\n  padding: 10px 15px;\n  box-shadow: none;\n  border-radius: 0;\n  color: var(--default-color);\n  background-color: color-mix(in srgb, var(--background-color), transparent 20%);\n  border-color: color-mix(in srgb, var(--default-color), transparent 80%);\n}\n\n.KeysHome .get-started .php-email-form input[type=\"text\"]:focus,\n.KeysHome .get-started .php-email-form input[type=\"email\"]:focus,\n.KeysHome .get-started .php-email-form textarea:focus {\n  border-color: var(--accent-color);\n}\n\n.KeysHome .get-started .php-email-form input[type=\"text\"]::placeholder,\n.KeysHome .get-started .php-email-form input[type=\"email\"]::placeholder,\n.KeysHome .get-started .php-email-form textarea::placeholder {\n  color: color-mix(in srgb, var(--default-color), transparent 70%);\n}\n\n.KeysHome .get-started .php-email-form button[type=\"submit\"] {\n  color: var(--contrast-color);\n  background: var(--accent-color);\n  border: 0;\n  padding: 10px 30px;\n  transition: 0.4s;\n  border-radius: 4px;\n}\n\n.KeysHome .get-started .php-email-form button[type=\"submit\"]:hover {\n  background: color-mix(in srgb, var(--accent-color), transparent 20%);\n}\n\n/*--------------------------------------------------------------\n# Constructions Section\n--------------------------------------------------------------*/\n.KeysHome .constructions .card-item {\n  background-color: var(--surface-color);\n  border: 1px solid color-mix(in srgb, var(--default-color), transparent 85%);\n  position: relative;\n  border-radius: 0;\n}\n\n.KeysHome .constructions .card-item .card-bg {\n  min-height: 300px;\n  position: relative;\n}\n\n.KeysHome .constructions .card-item .card-bg img {\n  position: absolute;\n  inset: 0;\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center;\n  z-index: 1;\n}\n\n.KeysHome .constructions .card-item .card-body {\n  padding: 30px;\n}\n\n.KeysHome .constructions .card-item h4 {\n  font-weight: 700;\n  font-size: 20px;\n  margin-bottom: 15px;\n}\n\n.KeysHome .constructions .card-item p {\n  color: color-mix(in srgb, var(--default-color), transparent 40%);\n  margin: 0;\n}\n\n/*--------------------------------------------------------------\n# Services Section\n--------------------------------------------------------------*/\n.KeysHome .services .service-item {\n  background-color: var(--surface-color);\n  padding: 40px;\n  box-shadow: 0px 0 30px rgba(0, 0, 0, 0.1);\n  height: 100%;\n}\n\n.KeysHome .services .service-item .icon {\n  width: 48px;\n  height: 48px;\n  position: relative;\n  margin-bottom: 50px;\n}\n\n.KeysHome .services .service-item .icon svg {\n  color: var(--heading-color);\n  font-size: 54px;\n  transition: ease-in-out 0.3s;\n  z-index: 2;\n  position: relative;\n}\n\n.KeysHome .services .service-item .icon {\n  display: flex;\n  width: 80px;\n  height: 80px;\n  justify-content: center;\n  align-items: center;\n  background: color-mix(in srgb, var(--heading-color), transparent 95%);\n  border-radius: 50px;\n  transition: 0.3s;\n}\n\n.KeysHome .services .service-item h3 {\n  color: color-mix(in srgb, var(--heading-color), transparent 20%);\n  font-weight: 700;\n  margin: 0 0 20px 0;\n  padding-bottom: 8px;\n  font-size: 22px;\n  position: relative;\n  display: inline-block;\n  border-bottom: 4px solid color-mix(in srgb, var(--heading-color), transparent 90%);\n  transition: 0.3s;\n}\n\n.KeysHome .services .service-item p {\n  line-height: 24px;\n  font-size: 14px;\n  margin-bottom: 0;\n}\n\n.KeysHome .services .service-item .readmore {\n  margin-top: 15px;\n  display: inline-block;\n  color: color-mix(in srgb, var(--default-color), transparent 30%);\n}\n\n.KeysHome .services .service-item:hover .icon i {\n  color: var(--heading-color);\n}\n\n.KeysHome .services .service-item:hover .icon:before {\n  background: var(--accent-color);\n}\n\n.KeysHome .services .service-item:hover h3 {\n  border-color: var(--accent-color);\n  color: var(--heading-color);\n}\n\n.KeysHome .services .service-item:hover .readmore {\n  color: var(--accent-color);\n}\n\n/*--------------------------------------------------------------\n# Alt Services Section\n--------------------------------------------------------------*/\n.KeysHome .alt-services .features-image {\n  position: relative;\n  min-height: 400px;\n}\n\n.KeysHome .alt-services .features-image img {\n  position: absolute;\n  inset: 0;\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  z-index: 1;\n}\n\n.KeysHome .alt-services h3 {\n  font-size: 28px;\n  font-weight: 700;\n  margin-bottom: 20px;\n  padding-bottom: 20px;\n  position: relative;\n}\n\n.KeysHome .alt-services h3:after {\n  content: \"\";\n  background: var(--accent-color);\n  position: absolute;\n  display: block;\n  width: 50px;\n  height: 3px;\n  left: 0;\n  bottom: 0;\n}\n\n.KeysHome .alt-services .icon-box {\n  margin-top: 50px;\n}\n\n.KeysHome .alt-services .icon-box svg {\n  color: var(--accent-color);\n  background-color: var(--surface-color);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 25px;\n  font-size: 28px;\n  width: 56px;\n  height: 56px;\n  border-radius: 4px;\n  line-height: 0;\n  box-shadow: 0px 2px 30px rgba(0, 0, 0, 0.1);\n  transition: 0.3s;\n}\n\n.KeysHome .alt-services .icon-box:hover svg {\n  background-color: var(--accent-color);\n  color: var(--contrast-color);\n}\n\n.KeysHome .alt-services .icon-box h4 {\n  font-weight: 700;\n  margin-bottom: 10px;\n  font-size: 18px;\n}\n\n.KeysHome .alt-services .icon-box h4 a {\n  color: var(--heading-color);\n  transition: 0.3s;\n}\n\n.KeysHome .alt-services .icon-box h4 a:hover {\n  color: var(--accent-color);\n}\n\n.KeysHome .alt-services .icon-box p {\n  line-height: 24px;\n  font-size: 14px;\n  margin-bottom: 0;\n}\n\n/*--------------------------------------------------------------\n# Features Section\n--------------------------------------------------------------*/\n.KeysHome .features .nav-tabs {\n  border: 0;\n}\n\n.KeysHome .features .nav-link {\n  color: var(--heading-color);\n  padding: 15px 0;\n  transition: 0.3s;\n  border-radius: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  height: 100%;\n  border: 0;\n  border-bottom: 4px solid color-mix(in srgb, var(--default-color), transparent 90%);\n}\n\n.KeysHome .features .nav-link i {\n  padding-right: 15px;\n  font-size: 48px;\n}\n\n.KeysHome .features .nav-link h4 {\n  font-size: 18px;\n  font-weight: 600;\n  margin: 0;\n}\n\n@media (max-width: 575px) {\n  .KeysHome .features .nav-link h4 {\n    font-size: 16px;\n  }\n}\n\n.KeysHome .features .nav-link:hover {\n  color: var(--accent-color);\n  border-color: color-mix(in srgb, var(--default-color), transparent 80%);\n}\n\n.KeysHome .features .nav-link.active {\n  background-color: var(--background-color);\n  color: var(--accent-color);\n  border-color: var(--accent-color);\n}\n\n.KeysHome .features .tab-content {\n  margin-top: 30px;\n}\n\n.KeysHome .features .features-tabs h3 {\n  color: var(--heading-color);\n  font-weight: 700;\n  font-size: 32px;\n  position: relative;\n  margin-bottom: 20px;\n  padding-bottom: 20px;\n}\n\n.KeysHome .features .features-tabs h3:after {\n  content: \"\";\n  position: absolute;\n  display: block;\n  width: 60px;\n  height: 3px;\n  background: var(--accent-color);\n  left: 0;\n  bottom: 0;\n}\n\n.KeysHome .features .features-tabs ul {\n  list-style: none;\n  padding: 0;\n}\n\n.KeysHome .features .features-tabs ul li {\n  padding-top: 10px;\n}\n\n.KeysHome .features .features-tabs ul svg {\n  font-size: 20px;\n  padding-right: 4px;\n  color: var(--accent-color);\n}\n\n.KeysHome .features .features-tabs p:last-child {\n  margin-bottom: 0;\n}\n\n/*--------------------------------------------------------------\n# Projects Section\n--------------------------------------------------------------*/\n.KeysHome .projects .portfolio-filters {\n  padding: 0;\n  margin: 0 auto 20px auto;\n  list-style: none;\n  text-align: center;\n}\n\n.KeysHome .projects .portfolio-filters li {\n  cursor: pointer;\n  display: inline-block;\n  padding: 0;\n  font-size: 18px;\n  font-weight: 500;\n  margin: 0 10px;\n  line-height: 1;\n  margin-bottom: 5px;\n  transition: all 0.3s ease-in-out;\n}\n\n.KeysHome .projects .portfolio-filters li:hover,\n.KeysHome .projects .portfolio-filters li.filter-active {\n  color: var(--accent-color);\n}\n\n.KeysHome .projects .portfolio-filters li:first-child {\n  margin-left: 0;\n}\n\n.KeysHome .projects .portfolio-filters li:last-child {\n  margin-right: 0;\n}\n\n@media (max-width: 575px) {\n  .KeysHome .projects .portfolio-filters li {\n    font-size: 14px;\n    margin: 0 5px;\n  }\n}\n\n.KeysHome .projects .portfolio-content {\n  position: relative;\n  overflow: hidden;\n}\n\n.KeysHome .projects .portfolio-content img {\n  transition: 0.3s;\n}\n\n.KeysHome .projects .portfolio-content .portfolio-info {\n  opacity: 0;\n  position: absolute;\n  inset: 0;\n  z-index: 3;\n  transition: all ease-in-out 0.3s;\n  background: rgba(0, 0, 0, 0.6);\n  padding: 15px;\n}\n\n.KeysHome .projects .portfolio-content .portfolio-info h4 {\n  font-size: 14px;\n  padding: 5px 10px;\n  font-weight: 400;\n  color: #ffffff;\n  display: inline-block;\n  background-color: var(--accent-color);\n}\n\n.KeysHome .projects .portfolio-content .portfolio-info p {\n  position: absolute;\n  bottom: 10px;\n  text-align: center;\n  display: inline-block;\n  left: 0;\n  right: 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.KeysHome .projects .portfolio-content .portfolio-info .preview-link,\n.KeysHome .projects .portfolio-content .portfolio-info .details-link {\n  position: absolute;\n  left: calc(50% - 40px);\n  font-size: 26px;\n  top: calc(50% - 14px);\n  color: #fff;\n  transition: 0.3s;\n  line-height: 1.2;\n}\n\n.KeysHome .projects .portfolio-content .portfolio-info .preview-link:hover,\n.KeysHome .projects .portfolio-content .portfolio-info .details-link:hover {\n  color: var(--accent-color);\n}\n\n.KeysHome .projects .portfolio-content .portfolio-info .details-link {\n  left: 50%;\n  font-size: 34px;\n  line-height: 0;\n}\n\n.KeysHome .projects .portfolio-content:hover .portfolio-info {\n  opacity: 1;\n}\n\n.KeysHome .projects .portfolio-content:hover img {\n  transform: scale(1.1);\n}\n\n/*--------------------------------------------------------------\n# Testimonials Section\n--------------------------------------------------------------*/\n.KeysHome .testimonials .testimonial-wrap {\n  padding-left: 50px;\n}\n\n.KeysHome .testimonials .testimonials-carousel,\n.KeysHome .testimonials .testimonials-slider {\n  overflow: hidden;\n}\n\n.KeysHome .testimonials .testimonial-item {\n  background-color: var(--surface-color);\n  box-shadow: 0px 2px 15px rgba(0, 0, 0, 0.1);\n  box-sizing: content-box;\n  padding: 30px 30px 30px 60px;\n  margin: 30px 15px;\n  min-height: 200px;\n  position: relative;\n}\n\n.KeysHome .testimonials .testimonial-item .testimonial-img {\n  width: 90px;\n  border-radius: 10px;\n  border: 6px solid var(--background-color);\n  position: absolute;\n  left: -45px;\n}\n\n.KeysHome .testimonials .testimonial-item h3 {\n  font-size: 18px;\n  font-weight: bold;\n  margin: 10px 0 5px 0;\n}\n\n.KeysHome .testimonials .testimonial-item h4 {\n  color: color-mix(in srgb, var(--default-color), transparent 50%);\n  font-size: 14px;\n  margin: 0;\n}\n\n.KeysHome .testimonials .testimonial-item .stars {\n  margin: 10px 0;\n}\n\n.KeysHome .testimonials .testimonial-item .stars i {\n  color: #ffc107;\n  margin: 0 1px;\n}\n\n.KeysHome .testimonials .testimonial-item .quote-icon-left,\n.KeysHome .testimonials .testimonial-item .quote-icon-right {\n  color: color-mix(in srgb, var(--accent-color), transparent 60%);\n  font-size: 26px;\n  line-height: 0;\n}\n\n.KeysHome .testimonials .testimonial-item .quote-icon-left {\n  display: inline-block;\n  left: -5px;\n  position: relative;\n}\n\n.KeysHome .testimonials .testimonial-item .quote-icon-right {\n  display: inline-block;\n  right: -5px;\n  position: relative;\n  top: 10px;\n  transform: scale(-1, -1);\n}\n\n.KeysHome .testimonials .testimonial-item p {\n  font-style: italic;\n  margin: 15px auto 15px auto;\n}\n\n.KeysHome .testimonials .swiper-wrapper {\n  height: auto;\n}\n\n.KeysHome .testimonials .swiper-pagination {\n  margin-top: 20px;\n  position: relative;\n}\n\n.KeysHome .testimonials .swiper-pagination .swiper-pagination-bullet {\n  width: 12px;\n  height: 12px;\n  background-color: var(--background-color);\n  opacity: 1;\n  border: 1px solid var(--accent-color);\n}\n\n.KeysHome .testimonials .swiper-pagination .swiper-pagination-bullet-active {\n  background-color: var(--accent-color);\n}\n\n@media (max-width: 767px) {\n  .KeysHome .testimonials .testimonial-wrap {\n    padding-left: 0;\n  }\n\n  .KeysHome .testimonials .testimonials-carousel,\n  .KeysHome .testimonials .testimonials-slider {\n    overflow: hidden;\n  }\n\n  .KeysHome .testimonials .testimonial-item {\n    padding: 30px;\n    margin: 15px;\n  }\n\n  .KeysHome .testimonials .testimonial-item .testimonial-img {\n    position: static;\n    left: auto;\n  }\n}\n\n/*--------------------------------------------------------------\n# Recent Blog Posts Section\n--------------------------------------------------------------*/\n.KeysHome .recent-blog-posts .post-item {\n  background: var(--surface-color);\n  box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.1);\n  transition: 0.3s;\n}\n\n.KeysHome .recent-blog-posts .post-item .post-img img {\n  transition: 0.5s;\n}\n\n.KeysHome .recent-blog-posts .post-item .post-date {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  background-color: var(--accent-color);\n  color: var(--contrast-color);\n  text-transform: uppercase;\n  font-size: 13px;\n  padding: 6px 12px;\n  font-weight: 500;\n}\n\n.KeysHome .recent-blog-posts .post-item .post-content {\n  padding: 30px;\n}\n\n.KeysHome .recent-blog-posts .post-item .post-title {\n  color: var(--heading-color);\n  font-size: 20px;\n  font-weight: 700;\n  transition: 0.3s;\n  margin-bottom: 15px;\n}\n\n.KeysHome .recent-blog-posts .post-item .meta i {\n  font-size: 16px;\n  color: var(--accent-color);\n}\n\n.KeysHome .recent-blog-posts .post-item .meta span {\n  font-size: 15px;\n  color: color-mix(in srgb, var(--default-color), transparent 50%);\n}\n\n.KeysHome .recent-blog-posts .post-item hr {\n  color: color-mix(in srgb, var(--default-color), transparent 80%);\n  margin: 20px 0;\n}\n\n.KeysHome .recent-blog-posts .post-item .readmore {\n  display: flex;\n  align-items: center;\n  font-weight: 600;\n  line-height: 1;\n  transition: 0.3s;\n  color: color-mix(in srgb, var(--default-color), transparent 40%);\n}\n\n.KeysHome .recent-blog-posts .post-item .readmore i {\n  line-height: 0;\n  margin-left: 6px;\n  font-size: 16px;\n}\n\n.KeysHome .recent-blog-posts .post-item:hover .post-title,\n.KeysHome .recent-blog-posts .post-item:hover .readmore {\n  color: var(--accent-color);\n}\n\n.KeysHome .recent-blog-posts .post-item:hover .post-img img {\n  transform: scale(1.1);\n}\n\n/*--------------------------------------------------------------\n# About Section\n--------------------------------------------------------------*/\n.KeysHome .about .inner-title {\n  font-size: 2.75rem;\n  font-weight: 700;\n  margin: 30px 0;\n}\n\n@media (min-width: 991px) {\n  .KeysHome .about .inner-title {\n    max-width: 65%;\n    margin: 0 0 80px 0;\n  }\n}\n\n.KeysHome .about .our-story {\n  padding: 40px;\n  background-color: color-mix(in srgb, var(--default-color), transparent 96%);\n}\n\n@media (min-width: 991px) {\n  .KeysHome .about .our-story {\n    padding-right: 35%;\n  }\n}\n\n.KeysHome .about .our-story h4 {\n  text-transform: uppercase;\n  font-size: 1.1rem;\n  color: color-mix(in srgb, var(--default-color), transparent 50%);\n}\n\n.KeysHome .about .our-story h3 {\n  font-size: 2.25rem;\n  font-weight: 700;\n  color: color-mix(in srgb, var(--default-color), transparent 20%);\n}\n\n.KeysHome .about .our-story p:last-child {\n  margin-bottom: 0;\n}\n\n.KeysHome .about ul {\n  list-style: none;\n  padding: 0;\n  font-size: 15px;\n}\n\n.KeysHome .about ul li {\n  padding: 5px 0;\n  display: flex;\n  align-items: center;\n}\n\n.KeysHome .about ul i {\n  font-size: 1.25rem;\n  margin-right: 0.5rem;\n  line-height: 1.2;\n  color: var(--accent-color);\n}\n\n.KeysHome .about .watch-video i {\n  font-size: 2rem;\n  transition: 0.3s;\n  color: var(--accent-color);\n}\n\n.KeysHome .about .watch-video a {\n  font-weight: 600;\n  color: color-mix(in srgb, var(--default-color), transparent 20%);\n  margin-left: 8px;\n  transition: 0.3s;\n}\n\n.KeysHome .about .watch-video:hover a {\n  color: var(--accent-color);\n}\n\n.KeysHome .about .about-img {\n  min-height: 400px;\n  position: relative;\n}\n\n@media (min-width: 992px) {\n  .KeysHome .about .about-img {\n    position: absolute;\n    top: 0;\n    right: 0;\n    min-height: 600px;\n  }\n}\n\n.KeysHome .about .about-img img {\n  position: absolute;\n  inset: 0;\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center;\n  z-index: 1;\n}\n\n/*--------------------------------------------------------------\n# Stats Counter Section\n--------------------------------------------------------------*/\n.KeysHome .stats-counter .stats-item {\n  box-shadow: 0px 0 30px rgba(0, 0, 0, 0.1);\n  padding: 30px;\n}\n\n.KeysHome .stats-counter .stats-item i {\n  color: var(--accent-color);\n  font-size: 42px;\n  line-height: 0;\n  margin-right: 20px;\n}\n\n.KeysHome .stats-counter .stats-item span {\n  color: var(--heading-color);\n  font-size: 36px;\n  display: block;\n  font-weight: 600;\n}\n\n.KeysHome .stats-counter .stats-item p {\n  padding: 0;\n  margin: 0;\n  font-family: var(--heading-font);\n  font-size: 16px;\n}\n\n/*--------------------------------------------------------------\n# Alt Services 2 Section\n--------------------------------------------------------------*/\n.KeysHome .alt-services-2 .features-image {\n  position: relative;\n  min-height: 400px;\n}\n\n.KeysHome .alt-services-2 .features-image img {\n  position: absolute;\n  inset: 0;\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  z-index: 1;\n}\n\n.KeysHome .alt-services-2 h3 {\n  font-size: 28px;\n  font-weight: 700;\n  margin-bottom: 20px;\n}\n\n.KeysHome .alt-services-2 .icon-box {\n  margin-top: 30px;\n}\n\n.KeysHome .alt-services-2 .icon-box i {\n  color: var(--accent-color);\n  margin-right: 15px;\n  font-size: 24px;\n  line-height: 1.2;\n}\n\n.KeysHome .alt-services-2 .icon-box h4 {\n  font-weight: 600;\n  margin-bottom: 10px;\n  font-size: 18px;\n}\n\n.KeysHome .alt-services-2 .icon-box p {\n  line-height: 24px;\n  font-size: 14px;\n  margin-bottom: 0;\n}\n\n/*--------------------------------------------------------------\n# Team Section\n--------------------------------------------------------------*/\n.KeysHome .team .member {\n  position: relative;\n}\n\n.KeysHome .team .member .member-img {\n  margin: 0 80px;\n  border-radius: 50%;\n  overflow: hidden;\n  position: relative;\n}\n\n@media (max-width: 1024px) {\n  .KeysHome .team .member .member-img {\n    margin: 0 60px;\n  }\n}\n\n.KeysHome .team .member .member-img img {\n  position: relative;\n  z-index: 1;\n}\n\n.KeysHome .team .member .member-img .social {\n  position: absolute;\n  inset: 0;\n  background-color: rgba(0, 0, 0, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 2;\n  padding-bottom: 20px;\n  transition: 0.3s;\n  visibility: hidden;\n  opacity: 0;\n}\n\n.KeysHome .team .member .member-img .social a {\n  transition: 0.3s;\n  color: var(--contrast-color);\n  font-size: 20px;\n  margin: 0 8px;\n}\n\n.KeysHome .team .member .member-img .social a:hover {\n  color: var(--accent-color);\n}\n\n.KeysHome .team .member .member-info {\n  margin-top: 30px;\n}\n\n.KeysHome .team .member .member-info h4 {\n  font-weight: 700;\n  margin-bottom: 6px;\n  font-size: 18px;\n}\n\n.KeysHome .team .member .member-info span {\n  font-style: italic;\n  display: block;\n  font-size: 15px;\n  color: color-mix(in srgb, var(--default-color), transparent 40%);\n  margin-bottom: 10px;\n}\n\n.KeysHome .team .member .member-info p {\n  margin-bottom: 0;\n  font-size: 14px;\n}\n\n.KeysHome .team .member:hover .member-img .social {\n  padding-bottom: 0;\n  visibility: visible;\n  opacity: 1;\n}\n\n/*--------------------------------------------------------------\n# Features Cards Section\n--------------------------------------------------------------*/\n.KeysHome .features-cards h3 {\n  font-size: 20px;\n  font-weight: 700;\n}\n\n.KeysHome .features-cards p {\n  font-size: 15px;\n  color: color-mix(in srgb, var(--default-color), transparent 20%);\n}\n\n.KeysHome .features-cards ul li {\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n  padding-top: 10px;\n  color: color-mix(in srgb, var(--default-color), transparent 30%);\n}\n\n.KeysHome .features-cards ul li i {\n  font-size: 16px;\n  color: var(--accent-color);\n  margin-right: 6px;\n}\n\n/*--------------------------------------------------------------\n# Service Details Section\n--------------------------------------------------------------*/\n.KeysHome .service-details .services-list {\n  background-color: var(--surface-color);\n  padding: 10px 30px;\n  border: 1px solid color-mix(in srgb, var(--default-color), transparent 90%);\n  margin-bottom: 20px;\n}\n\n.KeysHome .service-details .services-list a {\n  display: block;\n  line-height: 1;\n  padding: 8px 0 8px 15px;\n  border-left: 3px solid color-mix(in srgb, var(--default-color), transparent 70%);\n  margin: 20px 0;\n  color: color-mix(in srgb, var(--default-color), transparent 20%);\n  transition: 0.3s;\n}\n\n.KeysHome .service-details .services-list a.active {\n  color: var(--heading-color);\n  font-weight: 700;\n  border-color: var(--accent-color);\n}\n\n.KeysHome .service-details .services-list a:hover {\n  border-color: var(--accent-color);\n}\n\n.KeysHome .service-details .services-img {\n  margin-bottom: 20px;\n}\n\n.KeysHome .service-details h3 {\n  font-size: 26px;\n  font-weight: 700;\n}\n\n.KeysHome .service-details h4 {\n  font-size: 20px;\n  font-weight: 700;\n}\n\n.KeysHome .service-details p {\n  font-size: 15px;\n}\n\n.KeysHome .service-details ul {\n  list-style: none;\n  padding: 0;\n  font-size: 15px;\n}\n\n.KeysHome .service-details ul li {\n  padding: 5px 0;\n  display: flex;\n  align-items: center;\n}\n\n.KeysHome .service-details ul i {\n  font-size: 20px;\n  margin-right: 8px;\n  color: var(--accent-color);\n}\n\n/*--------------------------------------------------------------\n# Project Details Section\n--------------------------------------------------------------*/\n.KeysHome .project-details .portfolio-details-slider img {\n  width: 100%;\n}\n\n.KeysHome .project-details .swiper-wrapper {\n  height: auto;\n}\n\n.KeysHome .project-details .swiper-button-prev,\n.KeysHome .project-details .swiper-button-next {\n  width: 48px;\n  height: 48px;\n}\n\n.KeysHome .project-details .swiper-button-prev:after,\n.KeysHome .project-details .swiper-button-next:after {\n  color: rgba(255, 255, 255, 0.8);\n  background-color: rgba(0, 0, 0, 0.15);\n  font-size: 24px;\n  border-radius: 50%;\n  width: 48px;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: 0.3s;\n}\n\n.KeysHome .project-details .swiper-button-prev:hover:after,\n.KeysHome .project-details .swiper-button-next:hover:after {\n  background-color: rgba(0, 0, 0, 0.3);\n}\n\n@media (max-width: 575px) {\n  .KeysHome .project-details .swiper-button-prev,\n  .KeysHome .project-details .swiper-button-next {\n    display: none;\n  }\n}\n\n.KeysHome .project-details .swiper-pagination {\n  margin-top: 20px;\n  position: relative;\n}\n\n.KeysHome .project-details .swiper-pagination .swiper-pagination-bullet {\n  width: 10px;\n  height: 10px;\n  background-color: color-mix(in srgb, var(--default-color), transparent 85%);\n  opacity: 1;\n}\n\n.KeysHome .project-details .swiper-pagination .swiper-pagination-bullet-active {\n  background-color: var(--accent-color);\n}\n\n.KeysHome .project-details .portfolio-info h3 {\n  font-size: 22px;\n  font-weight: 700;\n  margin-bottom: 20px;\n  padding-bottom: 20px;\n  position: relative;\n}\n\n.KeysHome .project-details .portfolio-info h3:after {\n  content: \"\";\n  position: absolute;\n  display: block;\n  width: 50px;\n  height: 3px;\n  background: var(--accent-color);\n  left: 0;\n  bottom: 0;\n}\n\n.KeysHome .project-details .portfolio-info ul {\n  list-style: none;\n  padding: 0;\n  font-size: 15px;\n}\n\n.KeysHome .project-details .portfolio-info ul li {\n  display: flex;\n  flex-direction: column;\n  padding-bottom: 15px;\n}\n\n.KeysHome .project-details .portfolio-info ul strong {\n  text-transform: uppercase;\n  font-weight: 400;\n  color: color-mix(in srgb, var(--default-color), transparent 50%);\n  font-size: 14px;\n}\n\n.KeysHome .project-details .portfolio-info .btn-visit {\n  padding: 8px 40px;\n  background: var(--accent-color);\n  color: var(--contrast-color);\n  border-radius: 50px;\n  transition: 0.3s;\n}\n\n.KeysHome .project-details .portfolio-info .btn-visit:hover {\n  background: color-mix(in srgb, var(--accent-color), transparent 20%);\n}\n\n.KeysHome .project-details .portfolio-description h2 {\n  font-size: 26px;\n  font-weight: 700;\n  margin-bottom: 20px;\n}\n\n.KeysHome .project-details .portfolio-description p {\n  padding: 0;\n}\n\n.KeysHome .project-details .portfolio-description .testimonial-item {\n  padding: 30px 30px 0 30px;\n  position: relative;\n  background: color-mix(in srgb, var(--default-color), transparent 97%);\n  margin-bottom: 50px;\n}\n\n.KeysHome .project-details .portfolio-description .testimonial-item .testimonial-img {\n  width: 90px;\n  border-radius: 50px;\n  border: 6px solid var(--background-color);\n  float: left;\n  margin: 0 10px 0 0;\n}\n\n.KeysHome .project-details .portfolio-description .testimonial-item h3 {\n  font-size: 18px;\n  font-weight: bold;\n  margin: 15px 0 5px 0;\n  padding-top: 20px;\n}\n\n.KeysHome .project-details .portfolio-description .testimonial-item h4 {\n  font-size: 14px;\n  color: #6c757d;\n  margin: 0;\n}\n\n.KeysHome .project-details .portfolio-description .testimonial-item .quote-icon-left,\n.KeysHome .project-details .portfolio-description .testimonial-item .quote-icon-right {\n  color: color-mix(in srgb, var(--accent-color), transparent 50%);\n  font-size: 26px;\n  line-height: 0;\n}\n\n.KeysHome .project-details .portfolio-description .testimonial-item .quote-icon-left {\n  display: inline-block;\n  left: -5px;\n  position: relative;\n}\n\n.KeysHome .project-details .portfolio-description .testimonial-item .quote-icon-right {\n  display: inline-block;\n  right: -5px;\n  position: relative;\n  top: 10px;\n  transform: scale(-1, -1);\n}\n\n.KeysHome .project-details .portfolio-description .testimonial-item p {\n  font-style: italic;\n  margin: 0 0 15px 0 0 0;\n  padding: 0;\n}\n\n/*--------------------------------------------------------------\n# Blog Posts Section\n--------------------------------------------------------------*/\n.KeysHome .blog-posts article {\n  background-color: var(--surface-color);\n  box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.1);\n  transition: 0.3s;\n}\n\n.KeysHome .blog-posts .post-img img {\n  transition: 0.5s;\n}\n\n.KeysHome .blog-posts .post-date {\n  background-color: var(--accent-color);\n  color: var(--contrast-color);\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  text-transform: uppercase;\n  font-size: 13px;\n  padding: 6px 12px;\n  font-weight: 500;\n}\n\n.KeysHome .blog-posts .post-content {\n  padding: 30px;\n}\n\n.KeysHome .blog-posts .post-title {\n  font-size: 20px;\n  color: var(--heading-color);\n  font-weight: 700;\n  transition: 0.3s;\n  margin-bottom: 15px;\n}\n\n.KeysHome .blog-posts .meta i {\n  font-size: 16px;\n  color: var(--accent-color);\n}\n\n.KeysHome .blog-posts .meta span {\n  font-size: 15px;\n  color: color-mix(in srgb, var(--default-color), transparent 40%);\n}\n\n.KeysHome .blog-posts p {\n  margin-top: 20px;\n}\n\n.KeysHome .blog-posts hr {\n  color: color-mix(in srgb, var(--default-color), transparent 60%);\n  margin-bottom: 15px;\n}\n\n.KeysHome .blog-posts .readmore {\n  display: flex;\n  align-items: center;\n  font-weight: 600;\n  line-height: 1;\n  transition: 0.3s;\n  color: color-mix(in srgb, var(--heading-color), transparent 20%);\n}\n\n.KeysHome .blog-posts .readmore i {\n  line-height: 0;\n  margin-left: 6px;\n  font-size: 16px;\n}\n\n.KeysHome .blog-posts article:hover .post-title,\n.KeysHome .blog-posts article:hover .readmore {\n  color: var(--accent-color);\n}\n\n.KeysHome .blog-posts article:hover .post-img img {\n  transform: scale(1.1);\n}\n\n/*--------------------------------------------------------------\n# Blog Pagination Section\n--------------------------------------------------------------*/\n.KeysHome .blog-pagination {\n  padding-top: 0;\n  color: color-mix(in srgb, var(--default-color), transparent 40%);\n}\n\n.KeysHome .blog-pagination ul {\n  display: flex;\n  padding: 0;\n  margin: 0;\n  list-style: none;\n}\n\n.KeysHome .blog-pagination li {\n  margin: 0 5px;\n  transition: 0.3s;\n}\n\n.KeysHome .blog-pagination li a {\n  color: color-mix(in srgb, var(--default-color), transparent 40%);\n  padding: 7px 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.KeysHome .blog-pagination li a.active,\n.KeysHome .blog-pagination li a:hover {\n  background: var(--accent-color);\n  color: var(--contrast-color);\n}\n\n.KeysHome .blog-pagination li a.active a,\n.KeysHome .blog-pagination li a:hover a {\n  color: var(--contrast-color);\n}\n\n/*--------------------------------------------------------------\n# Blog Details Section\n--------------------------------------------------------------*/\n.KeysHome .blog-details {\n  padding-bottom: 30px;\n}\n\n.KeysHome .blog-details .article {\n  background-color: var(--surface-color);\n  padding: 30px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);\n}\n\n.KeysHome .blog-details .post-img {\n  margin: -30px -30px 20px -30px;\n  overflow: hidden;\n}\n\n.KeysHome .blog-details .title {\n  color: var(--heading-color);\n  font-size: 28px;\n  font-weight: 700;\n  padding: 0;\n  margin: 30px 0;\n}\n\n.KeysHome .blog-details .content {\n  margin-top: 20px;\n}\n\n.KeysHome .blog-details .content h3 {\n  font-size: 22px;\n  margin-top: 30px;\n  font-weight: bold;\n}\n\n.KeysHome .blog-details .content blockquote {\n  overflow: hidden;\n  background-color: color-mix(in srgb, var(--default-color), transparent 95%);\n  padding: 60px;\n  position: relative;\n  text-align: center;\n  margin: 20px 0;\n}\n\n.KeysHome .blog-details .content blockquote p {\n  color: var(--default-color);\n  line-height: 1.6;\n  margin-bottom: 0;\n  font-style: italic;\n  font-weight: 500;\n  font-size: 22px;\n}\n\n.KeysHome .blog-details .content blockquote:after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 3px;\n  background-color: var(--accent-color);\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n\n.KeysHome .blog-details .meta-top {\n  margin-top: 20px;\n  color: color-mix(in srgb, var(--default-color), transparent 40%);\n}\n\n.KeysHome .blog-details .meta-top ul {\n  display: flex;\n  flex-wrap: wrap;\n  list-style: none;\n  align-items: center;\n  padding: 0;\n  margin: 0;\n}\n\n.KeysHome .blog-details .meta-top ul li + li {\n  padding-left: 20px;\n}\n\n.KeysHome .blog-details .meta-top i {\n  font-size: 16px;\n  margin-right: 8px;\n  line-height: 0;\n  color: color-mix(in srgb, var(--default-color), transparent 40%);\n}\n\n.KeysHome .blog-details .meta-top a {\n  color: color-mix(in srgb, var(--default-color), transparent 40%);\n  font-size: 14px;\n  display: inline-block;\n  line-height: 1;\n}\n\n.KeysHome .blog-details .meta-bottom {\n  padding-top: 10px;\n  border-top: 1px solid color-mix(in srgb, var(--default-color), transparent 90%);\n}\n\n.KeysHome .blog-details .meta-bottom i {\n  color: color-mix(in srgb, var(--default-color), transparent 40%);\n  display: inline;\n}\n\n.KeysHome .blog-details .meta-bottom a {\n  color: color-mix(in srgb, var(--default-color), transparent 40%);\n  transition: 0.3s;\n}\n\n.KeysHome .blog-details .meta-bottom a:hover {\n  color: var(--accent-color);\n}\n\n.KeysHome .blog-details .meta-bottom .cats {\n  list-style: none;\n  display: inline;\n  padding: 0 20px 0 0;\n  font-size: 14px;\n}\n\n.KeysHome .blog-details .meta-bottom .cats li {\n  display: inline-block;\n}\n\n.KeysHome .blog-details .meta-bottom .tags {\n  list-style: none;\n  display: inline;\n  padding: 0;\n  font-size: 14px;\n}\n\n.KeysHome .blog-details .meta-bottom .tags li {\n  display: inline-block;\n}\n\n.KeysHome .blog-details .meta-bottom .tags li + li::before {\n  padding-right: 6px;\n  color: var(--default-color);\n  content: \",\";\n}\n\n.KeysHome .blog-details .meta-bottom .share {\n  font-size: 16px;\n}\n\n.KeysHome .blog-details .meta-bottom .share i {\n  padding-left: 5px;\n}\n\n/*--------------------------------------------------------------\n# Blog Author Section\n--------------------------------------------------------------*/\n.KeysHome .blog-author {\n  padding: 10px 0 40px 0;\n}\n\n.KeysHome .blog-author .author-container {\n  background-color: var(--surface-color);\n  padding: 20px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);\n}\n\n.KeysHome .blog-author img {\n  max-width: 120px;\n  margin-right: 20px;\n}\n\n.KeysHome .blog-author h4 {\n  font-weight: 600;\n  font-size: 20px;\n  margin-bottom: 0px;\n  padding: 0;\n  color: color-mix(in srgb, var(--default-color), transparent 20%);\n}\n\n.KeysHome .blog-author .social-links {\n  margin: 0 10px 10px 0;\n}\n\n.KeysHome .blog-author .social-links a {\n  color: color-mix(in srgb, var(--default-color), transparent 60%);\n  margin-right: 5px;\n}\n\n.KeysHome .blog-author p {\n  font-style: italic;\n  color: color-mix(in srgb, var(--default-color), transparent 30%);\n  margin-bottom: 0;\n}\n\n/*--------------------------------------------------------------\n# Blog Comments Section\n--------------------------------------------------------------*/\n.KeysHome .blog-comments {\n  padding: 10px 0;\n}\n\n.KeysHome .blog-comments .comments-count {\n  font-weight: bold;\n}\n\n.KeysHome .blog-comments .comment {\n  margin-top: 30px;\n  position: relative;\n}\n\n.KeysHome .blog-comments .comment .comment-img {\n  margin-right: 14px;\n}\n\n.KeysHome .blog-comments .comment .comment-img img {\n  width: 60px;\n}\n\n.KeysHome .blog-comments .comment h5 {\n  font-size: 16px;\n  margin-bottom: 2px;\n}\n\n.KeysHome .blog-comments .comment h5 a {\n  font-weight: bold;\n  color: var(--default-color);\n  transition: 0.3s;\n}\n\n.KeysHome .blog-comments .comment h5 a:hover {\n  color: var(--accent-color);\n}\n\n.KeysHome .blog-comments .comment h5 .reply {\n  padding-left: 10px;\n  color: color-mix(in srgb, var(--default-color), transparent 20%);\n}\n\n.KeysHome .blog-comments .comment h5 .reply i {\n  font-size: 20px;\n}\n\n.KeysHome .blog-comments .comment time {\n  display: block;\n  font-size: 14px;\n  color: color-mix(in srgb, var(--default-color), transparent 40%);\n  margin-bottom: 5px;\n}\n\n.KeysHome .blog-comments .comment.comment-reply {\n  padding-left: 40px;\n}\n\n/*--------------------------------------------------------------\n# Comment Form Section\n--------------------------------------------------------------*/\n.KeysHome .comment-form {\n  padding-top: 10px;\n}\n\n.KeysHome .comment-form form {\n  background-color: var(--surface-color);\n  margin-top: 30px;\n  padding: 30px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);\n}\n\n.KeysHome .comment-form form h4 {\n  font-weight: bold;\n  font-size: 22px;\n}\n\n.KeysHome .comment-form form p {\n  font-size: 14px;\n}\n\n.KeysHome .comment-form form input {\n  background-color: var(--surface-color);\n  color: var(--default-color);\n  border: 1px solid color-mix(in srgb, var(--default-color), transparent 70%);\n  font-size: 14px;\n  border-radius: 4px;\n  padding: 10px 10px;\n}\n\n.KeysHome .comment-form form input:focus {\n  color: var(--default-color);\n  background-color: var(--surface-color);\n  box-shadow: none;\n  border-color: var(--accent-color);\n}\n\n.KeysHome .comment-form form input::placeholder {\n  color: color-mix(in srgb, var(--default-color), transparent 50%);\n}\n\n.KeysHome .comment-form form textarea {\n  background-color: var(--surface-color);\n  color: var(--default-color);\n  border: 1px solid color-mix(in srgb, var(--default-color), transparent 70%);\n  border-radius: 4px;\n  padding: 10px 10px;\n  font-size: 14px;\n  height: 120px;\n}\n\n.KeysHome .comment-form form textarea:focus {\n  color: var(--default-color);\n  box-shadow: none;\n  border-color: var(--accent-color);\n  background-color: var(--surface-color);\n}\n\n.KeysHome .comment-form form textarea::placeholder {\n  color: color-mix(in srgb, var(--default-color), transparent 50%);\n}\n\n.KeysHome .comment-form form .form-group {\n  margin-bottom: 25px;\n}\n\n.KeysHome .comment-form form .btn-primary {\n  border-radius: 4px;\n  padding: 10px 20px;\n  border: 0;\n  background-color: var(--accent-color);\n  color: var(--contrast-color);\n}\n\n.KeysHome .comment-form form .btn-primary:hover {\n  color: var(--contrast-color);\n  background-color: color-mix(in srgb, var(--accent-color), transparent 20%);\n}\n\n/*--------------------------------------------------------------\n# Contact Section\n--------------------------------------------------------------*/\n.KeysHome .contact .info-item {\n  background-color: var(--surface-color);\n  padding: 20px 0 30px 0;\n  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);\n}\n\n.KeysHome .contact .info-item i {\n  font-size: 20px;\n  color: var(--accent-color);\n  width: 56px;\n  height: 56px;\n  font-size: 24px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 4px;\n  transition: all 0.3s ease-in-out;\n  border-radius: 50%;\n  border: 2px dotted color-mix(in srgb, var(--accent-color), transparent 40%);\n}\n\n.KeysHome .contact .info-item h3 {\n  font-size: 20px;\n  font-size: 18px;\n  font-weight: 700;\n  margin: 10px 0;\n}\n\n.KeysHome .contact .info-item p {\n  padding: 0;\n  margin-bottom: 0;\n  font-size: 14px;\n}\n\n.KeysHome .contact .php-email-form {\n  background-color: var(--surface-color);\n  height: 100%;\n  padding: 30px;\n  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);\n}\n\n@media (max-width: 575px) {\n  .KeysHome .contact .php-email-form {\n    padding: 20px;\n  }\n}\n\n.KeysHome .contact .php-email-form input[type=\"text\"],\n.KeysHome .contact .php-email-form input[type=\"email\"],\n.KeysHome .contact .php-email-form textarea {\n  font-size: 14px;\n  padding: 10px 15px;\n  box-shadow: none;\n  border-radius: 0;\n  color: var(--default-color);\n  background-color: var(--surface-color);\n  border-color: color-mix(in srgb, var(--default-color), transparent 80%);\n}\n\n.KeysHome .contact .php-email-form input[type=\"text\"]:focus,\n.KeysHome .contact .php-email-form input[type=\"email\"]:focus,\n.KeysHome .contact .php-email-form textarea:focus {\n  border-color: var(--accent-color);\n}\n\n.KeysHome .contact .php-email-form input[type=\"text\"]::placeholder,\n.KeysHome .contact .php-email-form input[type=\"email\"]::placeholder,\n.KeysHome .contact .php-email-form textarea::placeholder {\n  color: color-mix(in srgb, var(--default-color), transparent 70%);\n}\n\n.KeysHome .contact .php-email-form button[type=\"submit\"] {\n  color: var(--contrast-color);\n  background: var(--accent-color);\n  border: 0;\n  padding: 10px 30px;\n  transition: 0.4s;\n  border-radius: 50px;\n}\n\n.KeysHome .contact .php-email-form button[type=\"submit\"]:hover {\n  background: color-mix(in srgb, var(--accent-color), transparent 20%);\n}\n\n/*--------------------------------------------------------------\n# Starter Section Section\n--------------------------------------------------------------*/\n.KeysHome .starter-section {\n  /* Add your styles here */\n}\n\n/*--------------------------------------------------------------\n# Widgets\n--------------------------------------------------------------*/\n.KeysHome .widgets-container {\n  background-color: var(--surface-color);\n  padding: 30px;\n  margin: 60px 0 30px 0;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);\n}\n\n.KeysHome .widget-title {\n  color: var(--heading-color);\n  font-size: 20px;\n  font-weight: 700;\n  padding: 0;\n  margin: 0 0 20px 0;\n}\n\n.KeysHome .widget-item {\n  margin-bottom: 40px;\n}\n\n.KeysHome .widget-item:last-child {\n  margin-bottom: 0;\n}\n\n.KeysHome .search-widget form {\n  background: var(--background-color);\n  border: 1px solid color-mix(in srgb, var(--default-color), transparent 70%);\n  padding: 3px 10px;\n  position: relative;\n  transition: 0.3s;\n}\n\n.KeysHome .search-widget form input[type=\"text\"] {\n  border: 0;\n  padding: 4px;\n  border-radius: 4px;\n  width: calc(100% - 40px);\n  background-color: var(--background-color);\n  color: var(--default-color);\n}\n\n.KeysHome .search-widget form input[type=\"text\"]:focus {\n  outline: none;\n}\n\n.KeysHome .search-widget form button {\n  background: var(--accent-color);\n  color: var(--contrast-color);\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  border: 0;\n  font-size: 16px;\n  padding: 0 15px;\n  margin: -1px;\n  transition: 0.3s;\n  border-radius: 0 4px 4px 0;\n  line-height: 0;\n}\n\n.KeysHome .search-widget form button i {\n  line-height: 0;\n}\n\n.KeysHome .search-widget form button:hover {\n  background: color-mix(in srgb, var(--accent-color), transparent 20%);\n}\n\n.KeysHome .search-widget form:is(:focus-within) {\n  border-color: var(--accent-color);\n}\n\n.KeysHome .categories-widget ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.KeysHome .categories-widget ul li {\n  padding-bottom: 10px;\n}\n\n.KeysHome .categories-widget ul li:last-child {\n  padding-bottom: 0;\n}\n\n.KeysHome .categories-widget ul a {\n  color: color-mix(in srgb, var(--default-color), transparent 20%);\n  transition: 0.3s;\n}\n\n.KeysHome .categories-widget ul a:hover {\n  color: var(--accent-color);\n}\n\n.KeysHome .categories-widget ul a span {\n  padding-left: 5px;\n  color: color-mix(in srgb, var(--default-color), transparent 50%);\n  font-size: 14px;\n}\n\n.KeysHome .recent-posts-widget .post-item {\n  display: flex;\n  margin-bottom: 15px;\n}\n\n.KeysHome .recent-posts-widget .post-item:last-child {\n  margin-bottom: 0;\n}\n\n.KeysHome .recent-posts-widget .post-item img {\n  width: 80px;\n  margin-right: 15px;\n}\n\n.KeysHome .recent-posts-widget .post-item h4 {\n  font-size: 15px;\n  font-weight: bold;\n  margin-bottom: 5px;\n}\n\n.KeysHome .recent-posts-widget .post-item h4 a {\n  color: var(--default-color);\n  transition: 0.3s;\n}\n\n.KeysHome .recent-posts-widget .post-item h4 a:hover {\n  color: var(--accent-color);\n}\n\n.KeysHome .recent-posts-widget .post-item time {\n  display: block;\n  font-style: italic;\n  font-size: 14px;\n  color: color-mix(in srgb, var(--default-color), transparent 50%);\n}\n\n.KeysHome .tags-widget {\n  margin-bottom: -10px;\n}\n\n.KeysHome .tags-widget ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.KeysHome .tags-widget ul li {\n  display: inline-block;\n}\n\n.KeysHome .tags-widget ul a {\n  color: color-mix(in srgb, var(--default-color), transparent 30%);\n  font-size: 14px;\n  padding: 6px 14px;\n  margin: 0 6px 8px 0;\n  border: 1px solid color-mix(in srgb, var(--default-color), transparent 60%);\n  display: inline-block;\n  transition: 0.3s;\n}\n\n.KeysHome .tags-widget ul a:hover {\n  background: var(--accent-color);\n  color: var(--contrast-color);\n  border: 1px solid var(--accent-color);\n}\n\n.KeysHome .tags-widget ul a span {\n  padding-left: 5px;\n  color: color-mix(in srgb, var(--default-color), transparent 60%);\n  font-size: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
